export const arrowRight = (
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.37593 0.175736C6.61025 -0.0585786 6.99015 -0.0585787 7.22446 0.175736L9.62446 2.57574C9.85878 2.81005 9.85878 3.18995 9.62446 3.42426L7.22446 5.82426C6.99015 6.05858 6.61025 6.05858 6.37593 5.82426C6.14162 5.58995 6.14162 5.21005 6.37593 4.97574L7.75167 3.6H0.800196C0.468825 3.6 0.200195 3.33137 0.200195 3C0.200195 2.66863 0.468825 2.4 0.800196 2.4H7.75167L6.37593 1.02426C6.14162 0.78995 6.14162 0.410051 6.37593 0.175736Z"
      fill="currentColor"
    />
  </svg>
);
export const notifIcon = (
  <svg width="28" height="28" viewBox="0 3 24 24" fill="none">
    <path
      d="M17.5 19.8333H23.3333L21.6942 18.1942C21.2497 17.7497 21 17.1468 21 16.5182V12.8333C21 9.78549 19.0521 7.1926 16.3333 6.23165V5.83333C16.3333 4.54467 15.2887 3.5 14 3.5C12.7113 3.5 11.6667 4.54467 11.6667 5.83333V6.23165C8.94787 7.1926 6.99999 9.78549 6.99999 12.8333V16.5182C6.99999 17.1468 6.75026 17.7497 6.30574 18.1942L4.66666 19.8333H10.5M17.5 19.8333V21C17.5 22.933 15.933 24.5 14 24.5C12.067 24.5 10.5 22.933 10.5 21V19.8333M17.5 19.8333H10.5"
      stroke="#6C746B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const chevronBottom = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M19 9L12 16L5 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const closeIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z"
      fill="currentColor"
    />
  </svg>
);
export const closeIconRed = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="red">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z"
      fill="red"
    />
  </svg>
);
export const facebook = (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      d="M9.33269 8.95V13.8324H6.9472V8.95H4.96777V6.97097H6.9472V6.24803C6.9472 3.57281 8.13239 2.16748 10.6448 2.16748C11.4143 2.16748 11.6073 2.28308 12.0303 2.37841V4.33716C11.5564 4.25779 11.424 4.21768 10.9331 4.21768C10.3492 4.21768 10.0408 4.37124 9.75709 4.6775C9.47339 4.98418 9.33178 5.51561 9.33178 6.27176V6.97097H12.0321L11.3066 8.95H9.33178H9.33269Z"
      fill="currentColor"
    />
  </svg>
);
export const instagram = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.00542 1.75C2.76139 1.75 1.75 2.76139 1.75 4.00542V11.9946C1.75 13.2386 2.76139 14.25 4.00542 14.25H11.9946C13.2386 14.25 14.25 13.2386 14.25 11.9946V4.00542C14.25 2.76139 13.2386 1.75 11.9946 1.75H4.00542ZM2.90648 4.00493C2.90648 3.41036 3.38189 2.92407 3.9723 2.90648H11.9946C12.6002 2.90648 13.0935 3.39978 13.0935 4.00542V11.9941C13.0935 12.5997 12.6002 13.093 11.9946 13.093H4.00542C3.39978 13.093 2.90648 12.5997 2.90648 11.9941V4.00493ZM8.0003 5.05566C7.21448 5.05566 6.47411 5.3624 5.91825 5.91825C5.3624 6.47411 5.05566 7.21448 5.05566 8.0003C5.05566 8.78612 5.3624 9.52648 5.91825 10.0823C6.4741 10.6382 7.21402 10.9449 8.0003 10.9449C8.78612 10.9449 9.52648 10.6382 10.0823 10.0823C10.6382 9.52648 10.9449 8.78612 10.9449 8.0003C10.9449 7.21448 10.6382 6.47411 10.0823 5.91825C9.52648 5.3624 8.78612 5.05566 8.0003 5.05566ZM6.13022 8.0003C6.13022 6.96941 6.96941 6.13022 8.0003 6.13022C9.03118 6.13022 9.87037 6.96941 9.87037 8.0003C9.87037 9.03118 9.03118 9.87037 8.0003 9.87037C6.96941 9.87037 6.13022 9.03118 6.13022 8.0003ZM10.8754 4.44571C10.7781 4.85809 11.0335 5.27128 11.4459 5.36861C11.8583 5.46594 12.2715 5.21055 12.3688 4.79817C12.4661 4.3858 12.2107 3.9726 11.7984 3.87527C11.386 3.77794 10.9728 4.03334 10.8754 4.44571Z"
      fill="currentColor"
    />
  </svg>
);
export const dots = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 5L12 5.01M12 12L12 12.01M12 19L12 19.01M12 6C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6ZM12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13ZM12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const download = (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.7998 10.7C1.7998 10.3686 2.06843 10.1 2.3998 10.1H9.5998C9.93118 10.1 10.1998 10.3686 10.1998 10.7C10.1998 11.0313 9.93118 11.3 9.5998 11.3H2.3998C2.06843 11.3 1.7998 11.0313 1.7998 10.7ZM3.77554 6.07569C4.00985 5.84137 4.38975 5.84137 4.62407 6.07569L5.3998 6.85142L5.3998 2.29995C5.3998 1.96858 5.66843 1.69995 5.9998 1.69995C6.33117 1.69995 6.5998 1.96858 6.5998 2.29995L6.5998 6.85142L7.37554 6.07569C7.60985 5.84137 7.98975 5.84137 8.22407 6.07569C8.45838 6.31 8.45838 6.6899 8.22407 6.92422L6.42407 8.72422C6.31155 8.83674 6.15893 8.89995 5.9998 8.89995C5.84067 8.89995 5.68806 8.83674 5.57554 8.72422L3.77554 6.92422C3.54123 6.6899 3.54123 6.31 3.77554 6.07569Z"
      fill="currentColor"
    />
  </svg>
);
export const chevronLeft = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M7.5 9.5L4 6L7.5 2.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const chevronRight = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M4.5 2.5L8 6L4.5 9.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const toastSuccesIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M6.66667 4V9.33333M4 6.66667H9.33333M8 22.6667V28M5.33333 25.3333H10.6667M17.3333 4L20.381 13.1429L28 16L20.381 18.8571L17.3333 28L14.2857 18.8571L6.66667 16L14.2857 13.1429L17.3333 4Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const toastErrorIcon = (
  <svg width="31" height="31" viewBox="0 0 31 31" fill="none">
    <path
      d="M15.5 11.625V14.2083M15.5 19.375H15.5129M6.55105 24.5417H24.4489C26.4376 24.5417 27.6805 22.3889 26.6861 20.6667L17.7372 5.16667C16.7429 3.44444 14.2571 3.44444 13.2628 5.16667L4.31382 20.6667C3.3195 22.3889 4.5624 24.5417 6.55105 24.5417Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const trashIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M15.8333 5.83333L15.1105 15.9521C15.0482 16.8243 14.3225 17.5 13.4481 17.5H6.55184C5.67745 17.5 4.95171 16.8243 4.88941 15.9521L4.16665 5.83333M8.33331 9.16667V14.1667M11.6666 9.16667V14.1667M12.5 5.83333V3.33333C12.5 2.8731 12.1269 2.5 11.6666 2.5H8.33331C7.87308 2.5 7.49998 2.8731 7.49998 3.33333V5.83333M3.33331 5.83333H16.6666"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const searchIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.4765 12.8907C10.4957 13.5892 9.29583 14 8 14C4.68629 14 2 11.3137 2 8Z"
      fill="currentColor"
    />
  </svg>
);
export const tickIconGreen = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M2.5 6.5L4.5 8.5L9.5 3.5"
      stroke="#08A708"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowTop = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M5.25 8.25L9 4.5M9 4.5L12.75 8.25M9 4.5V13.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const arrowBottom = (
  <svg width="12" height="28" viewBox="0 0 12 24" fill="none">
    <path
      fill-rule="evenodd"
      clipRule="evenodd"
      d="M8.00003 0V12.5858L12 8.58579L13.4142 10L7.70714 15.7071C7.31661 16.0976 6.68345 16.0976 6.29292 15.7071L0.585815 10L2.00003 8.58579L6.00003 12.5858V0L8.00003 0Z"
      fill="currentColor"
    />
  </svg>
);
export const arrowLeft = (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.82424 9.32426C5.58992 9.55858 5.21003 9.55858 4.97571 9.32426L2.57571 6.92426C2.3414 6.68995 2.3414 6.31005 2.57571 6.07574L4.97571 3.67574C5.21003 3.44142 5.58993 3.44142 5.82424 3.67574C6.05855 3.91005 6.05855 4.28995 5.82424 4.52426L4.4485 5.9L8.99998 5.9C9.33135 5.9 9.59998 6.16863 9.59998 6.5C9.59998 6.83137 9.33135 7.1 8.99998 7.1L4.4485 7.1L5.82424 8.47574C6.05855 8.71005 6.05855 9.08995 5.82424 9.32426Z"
      fill="currentColor"
    />
  </svg>
);
export const plusIcon = (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.9998 2.2998C6.33118 2.2998 6.5998 2.56843 6.5998 2.8998V5.8998H9.5998C9.93118 5.8998 10.1998 6.16843 10.1998 6.4998C10.1998 6.83118 9.93117 7.0998 9.5998 7.0998H6.5998V10.0998C6.5998 10.4312 6.33118 10.6998 5.9998 10.6998C5.66843 10.6998 5.3998 10.4312 5.3998 10.0998V7.0998H2.3998C2.06843 7.0998 1.7998 6.83117 1.7998 6.4998C1.7998 6.16843 2.06843 5.8998 2.3998 5.8998L5.3998 5.8998V2.8998C5.3998 2.56843 5.66843 2.2998 5.9998 2.2998Z"
      fill="currentColor"
    />
  </svg>
);
export const viewList = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M19 12.75H8C7.80109 12.75 7.61032 12.671 7.46967 12.5303C7.32902 12.3897 7.25 12.1989 7.25 12C7.25 11.8011 7.32902 11.6103 7.46967 11.4697C7.61032 11.329 7.80109 11.25 8 11.25H19C19.1989 11.25 19.3897 11.329 19.5303 11.4697C19.671 11.6103 19.75 11.8011 19.75 12C19.75 12.1989 19.671 12.3897 19.5303 12.5303C19.3897 12.671 19.1989 12.75 19 12.75Z"
      fill="currentColor"
    />
    <path
      d="M19 8.25H8C7.80109 8.25 7.61032 8.17098 7.46967 8.03033C7.32902 7.88968 7.25 7.69891 7.25 7.5C7.25 7.30109 7.32902 7.11032 7.46967 6.96967C7.61032 6.82902 7.80109 6.75 8 6.75H19C19.1989 6.75 19.3897 6.82902 19.5303 6.96967C19.671 7.11032 19.75 7.30109 19.75 7.5C19.75 7.69891 19.671 7.88968 19.5303 8.03033C19.3897 8.17098 19.1989 8.25 19 8.25Z"
      fill="currentColor"
    />
    <path
      d="M19 17.25H8C7.80109 17.25 7.61032 17.171 7.46967 17.0303C7.32902 16.8897 7.25 16.6989 7.25 16.5C7.25 16.3011 7.32902 16.1103 7.46967 15.9697C7.61032 15.829 7.80109 15.75 8 15.75H19C19.1989 15.75 19.3897 15.829 19.5303 15.9697C19.671 16.1103 19.75 16.3011 19.75 16.5C19.75 16.6989 19.671 16.8897 19.5303 17.0303C19.3897 17.171 19.1989 17.25 19 17.25Z"
      fill="currentColor"
    />
    <path
      d="M5.00002 8.4999C4.87 8.50149 4.74093 8.47771 4.62002 8.4299C4.50052 8.37192 4.3895 8.2979 4.29002 8.2099C4.19734 8.11646 4.12401 8.00564 4.07425 7.8838C4.02448 7.76197 3.99926 7.6315 4.00002 7.4999C4.0037 7.23513 4.10728 6.98153 4.29002 6.7899C4.38389 6.69729 4.49637 6.62571 4.62002 6.5799C4.86348 6.47988 5.13656 6.47988 5.38002 6.5799C5.50277 6.62749 5.61491 6.69886 5.71002 6.7899C5.89275 6.98153 5.99633 7.23513 6.00002 7.4999C6.00078 7.6315 5.97555 7.76197 5.92579 7.8838C5.87602 8.00564 5.8027 8.11646 5.71002 8.2099C5.61054 8.2979 5.49951 8.37192 5.38002 8.4299C5.25911 8.47771 5.13003 8.50149 5.00002 8.4999Z"
      fill="currentColor"
    />
    <path
      d="M5.00002 13.0001C4.86934 12.9985 4.74024 12.9713 4.62002 12.9201C4.49883 12.8694 4.38722 12.7984 4.29002 12.7101C4.19734 12.6166 4.12401 12.5058 4.07425 12.384C4.02448 12.2622 3.99926 12.1317 4.00002 12.0001C4.0037 11.7353 4.10728 11.4817 4.29002 11.2901C4.38722 11.2018 4.49883 11.1307 4.62002 11.0801C4.80104 10.9961 5.00303 10.9683 5.20002 11.0001L5.38002 11.0601L5.56002 11.1501C5.6124 11.187 5.6625 11.2271 5.71002 11.2701C5.89749 11.4667 6.00144 11.7284 6.00002 12.0001C6.00002 12.2653 5.89466 12.5197 5.70712 12.7072C5.51959 12.8947 5.26523 13.0001 5.00002 13.0001Z"
      fill="currentColor"
    />
    <path
      d="M5.00023 17.5001C4.87022 17.5017 4.74114 17.478 4.62023 17.4301C4.50074 17.3722 4.38971 17.2981 4.29023 17.2101C4.2019 17.1129 4.13087 17.0013 4.08023 16.8801C4.02733 16.7604 4 16.631 4 16.5001C4 16.3693 4.02733 16.2398 4.08023 16.1201C4.13087 15.999 4.2019 15.8873 4.29023 15.7901C4.43086 15.6514 4.60943 15.5574 4.80342 15.52C4.99741 15.4826 5.19812 15.5036 5.38023 15.5801C5.50298 15.6277 5.61513 15.6991 5.71023 15.7901C5.79856 15.8873 5.86959 15.999 5.92023 16.1201C5.97314 16.2398 6.00047 16.3693 6.00047 16.5001C6.00047 16.631 5.97314 16.7604 5.92023 16.8801C5.86959 17.0013 5.79856 17.1129 5.71023 17.2101C5.61679 17.3028 5.50598 17.3761 5.38414 17.4259C5.2623 17.4757 5.13184 17.5009 5.00023 17.5001Z"
      fill="currentColor"
    />
  </svg>
);
export const viewGrid = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9 11.25H6C5.40326 11.25 4.83097 11.0129 4.40901 10.591C3.98705 10.169 3.75 9.59674 3.75 9V6C3.75 5.40326 3.98705 4.83097 4.40901 4.40901C4.83097 3.98705 5.40326 3.75 6 3.75H9C9.59674 3.75 10.169 3.98705 10.591 4.40901C11.0129 4.83097 11.25 5.40326 11.25 6V9C11.25 9.59674 11.0129 10.169 10.591 10.591C10.169 11.0129 9.59674 11.25 9 11.25ZM6 5.25C5.80189 5.25259 5.61263 5.33244 5.47253 5.47253C5.33244 5.61263 5.25259 5.80189 5.25 6V9C5.25259 9.19811 5.33244 9.38737 5.47253 9.52747C5.61263 9.66756 5.80189 9.74741 6 9.75H9C9.19811 9.74741 9.38737 9.66756 9.52747 9.52747C9.66756 9.38737 9.74741 9.19811 9.75 9V6C9.74741 5.80189 9.66756 5.61263 9.52747 5.47253C9.38737 5.33244 9.19811 5.25259 9 5.25H6Z"
      fill="currentColor"
    />
    <path
      d="M9 20.25H6C5.40326 20.25 4.83097 20.0129 4.40901 19.591C3.98705 19.169 3.75 18.5967 3.75 18V15C3.75 14.4033 3.98705 13.831 4.40901 13.409C4.83097 12.9871 5.40326 12.75 6 12.75H9C9.59674 12.75 10.169 12.9871 10.591 13.409C11.0129 13.831 11.25 14.4033 11.25 15V18C11.25 18.5967 11.0129 19.169 10.591 19.591C10.169 20.0129 9.59674 20.25 9 20.25ZM6 14.25C5.80189 14.2526 5.61263 14.3324 5.47253 14.4725C5.33244 14.6126 5.25259 14.8019 5.25 15V18C5.25259 18.1981 5.33244 18.3874 5.47253 18.5275C5.61263 18.6676 5.80189 18.7474 6 18.75H9C9.19811 18.7474 9.38737 18.6676 9.52747 18.5275C9.66756 18.3874 9.74741 18.1981 9.75 18V15C9.74741 14.8019 9.66756 14.6126 9.52747 14.4725C9.38737 14.3324 9.19811 14.2526 9 14.25H6Z"
      fill="currentColor"
    />
    <path
      d="M18 11.25H15C14.4033 11.25 13.831 11.0129 13.409 10.591C12.9871 10.169 12.75 9.59674 12.75 9V6C12.75 5.40326 12.9871 4.83097 13.409 4.40901C13.831 3.98705 14.4033 3.75 15 3.75H18C18.5967 3.75 19.169 3.98705 19.591 4.40901C20.0129 4.83097 20.25 5.40326 20.25 6V9C20.25 9.59674 20.0129 10.169 19.591 10.591C19.169 11.0129 18.5967 11.25 18 11.25ZM15 5.25C14.8019 5.25259 14.6126 5.33244 14.4725 5.47253C14.3324 5.61263 14.2526 5.80189 14.25 6V9C14.2526 9.19811 14.3324 9.38737 14.4725 9.52747C14.6126 9.66756 14.8019 9.74741 15 9.75H18C18.1981 9.74741 18.3874 9.66756 18.5275 9.52747C18.6676 9.38737 18.7474 9.19811 18.75 9V6C18.7474 5.80189 18.6676 5.61263 18.5275 5.47253C18.3874 5.33244 18.1981 5.25259 18 5.25H15Z"
      fill="currentColor"
    />
    <path
      d="M18 20.25H15C14.4033 20.25 13.831 20.0129 13.409 19.591C12.9871 19.169 12.75 18.5967 12.75 18V15C12.75 14.4033 12.9871 13.831 13.409 13.409C13.831 12.9871 14.4033 12.75 15 12.75H18C18.5967 12.75 19.169 12.9871 19.591 13.409C20.0129 13.831 20.25 14.4033 20.25 15V18C20.25 18.5967 20.0129 19.169 19.591 19.591C19.169 20.0129 18.5967 20.25 18 20.25ZM15 14.25C14.8019 14.2526 14.6126 14.3324 14.4725 14.4725C14.3324 14.6126 14.2526 14.8019 14.25 15V18C14.2526 18.1981 14.3324 18.3874 14.4725 18.5275C14.6126 18.6676 14.8019 18.7474 15 18.75H18C18.1981 18.7474 18.3874 18.6676 18.5275 18.5275C18.6676 18.3874 18.7474 18.1981 18.75 18V15C18.7474 14.8019 18.6676 14.6126 18.5275 14.4725C18.3874 14.3324 18.1981 14.2526 18 14.25H15Z"
      fill="currentColor"
    />
  </svg>
);
export const playIcon = (
  <svg width="31" height="33" viewBox="0 0 31 33" fill="none">
    <path
      d="M30.9443 16.8198L0.972113 32.9587L0.972115 0.680907L30.9443 16.8198Z"
      fill="currentColor"
    />
  </svg>
);
export const copyIcon = (
  <svg width="15" height="18" viewBox="0 0 15 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7C0 5.89543 0.895431 5 2 5H8C9.10457 5 10 5.89543 10 7V16C10 17.1046 9.10457 18 8 18H2C0.89543 18 0 17.1046 0 16V7ZM8 7L2 7V16H8V7Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2C4 0.895429 4.89543 0 6 0H13C14.1046 0 15 0.895431 15 2V13C15 14.1046 14.1046 15 13 15H11.6V13H13V2L6 2V3.30769H4V2Z"
      fill="currentColor"
    />
  </svg>
);
export const calendarIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M5.06107 21.0451L5.50191 20.4383L5.06107 21.0451ZM3.95491 19.9389L4.56168 19.4981L3.95491 19.9389ZM20.0451 19.9389L19.4383 19.4981L20.0451 19.9389ZM18.9389 21.0451L19.3798 21.6518L18.9389 21.0451ZM18.9389 4.95492L19.3798 4.34815L18.9389 4.95492ZM20.0451 6.06107L19.4383 6.50191L20.0451 6.06107ZM5.06107 4.95492L5.50191 5.56168H5.50191L5.06107 4.95492ZM3.95491 6.06107L4.56168 6.50191L3.95491 6.06107ZM19.2178 16.0616L19.1005 15.3208H19.1005L19.2178 16.0616ZM15.0616 20.2178L14.3208 20.1005V20.1005L15.0616 20.2178ZM9 13.25C8.58579 13.25 8.25 13.5858 8.25 14C8.25 14.4142 8.58579 14.75 9 14.75V13.25ZM15 14.75C15.4142 14.75 15.75 14.4142 15.75 14C15.75 13.5858 15.4142 13.25 15 13.25V14.75ZM14.25 5C14.25 5.41421 14.5858 5.75 15 5.75C15.4142 5.75 15.75 5.41421 15.75 5H14.25ZM15.75 2C15.75 1.58579 15.4142 1.25 15 1.25C14.5858 1.25 14.25 1.58579 14.25 2H15.75ZM8.25 5C8.25 5.41421 8.58579 5.75 9 5.75C9.41421 5.75 9.75 5.41421 9.75 5H8.25ZM9.75 2C9.75 1.58579 9.41421 1.25 9 1.25C8.58579 1.25 8.25 1.58579 8.25 2H9.75ZM20.9711 16L21.7206 16.0257L20.9711 16ZM3.02893 10L2.27937 9.97432L3.02893 10ZM20.9711 10L21.7206 9.97432L20.9711 10ZM12 21.25C10.1084 21.25 8.74999 21.249 7.69804 21.135C6.66013 21.0225 6.00992 20.8074 5.50191 20.4383L4.62023 21.6518C5.42656 22.2377 6.37094 22.5 7.53648 22.6263C8.68798 22.751 10.1418 22.75 12 22.75V21.25ZM2.25 13C2.25 14.8582 2.24897 16.312 2.37373 17.4635C2.50001 18.6291 2.76232 19.5734 3.34815 20.3798L4.56168 19.4981C4.19259 18.9901 3.97745 18.3399 3.865 17.302C3.75103 16.25 3.75 14.8916 3.75 13H2.25ZM5.50191 20.4383C5.14111 20.1762 4.82382 19.8589 4.56168 19.4981L3.34815 20.3798C3.70281 20.8679 4.13209 21.2972 4.62023 21.6518L5.50191 20.4383ZM19.4383 19.4981C19.1762 19.8589 18.8589 20.1762 18.4981 20.4383L19.3798 21.6518C19.8679 21.2972 20.2972 20.8679 20.6518 20.3798L19.4383 19.4981ZM18.4981 5.56168C18.8589 5.82382 19.1762 6.14111 19.4383 6.50191L20.6518 5.62023C20.2972 5.13209 19.8679 4.70281 19.3798 4.34815L18.4981 5.56168ZM4.62023 4.34815C4.13209 4.70281 3.70281 5.13209 3.34815 5.62023L4.56168 6.50191C4.82382 6.14111 5.14111 5.82382 5.50191 5.56168L4.62023 4.34815ZM19.1005 15.3208C16.6401 15.7105 14.7105 17.6401 14.3208 20.1005L15.8023 20.3352C16.0904 18.5166 17.5166 17.0904 19.3352 16.8023L19.1005 15.3208ZM9 14.75H15V13.25H9V14.75ZM20.9711 15.25C20.0888 15.25 19.5579 15.2484 19.1005 15.3208L19.3352 16.8023C19.647 16.7529 20.0338 16.75 20.9711 16.75L20.9711 15.25ZM20.25 13C20.25 14.1731 20.2499 15.1456 20.2215 15.9743L21.7206 16.0257C21.7501 15.1658 21.75 14.1648 21.75 13H20.25ZM20.2215 15.9743C20.158 17.8292 19.9509 18.7925 19.4383 19.4981L20.6518 20.3798C21.4537 19.2761 21.6564 17.8991 21.7206 16.0257L20.2215 15.9743ZM15.75 21.9711C15.75 21.0338 15.7529 20.647 15.8023 20.3352L14.3208 20.1005C14.2484 20.5579 14.25 21.0888 14.25 21.9711L15.75 21.9711ZM12 22.75C13.1648 22.75 14.1658 22.7501 15.0257 22.7206L14.9743 21.2215C14.1456 21.2499 13.1731 21.25 12 21.25V22.75ZM15.0257 22.7206C16.8991 22.6564 18.2761 22.4537 19.3798 21.6518L18.4981 20.4383C17.7925 20.9509 16.8292 21.158 14.9743 21.2215L15.0257 22.7206ZM3.75 13C3.75 11.8269 3.75009 10.8544 3.77849 10.0257L2.27937 9.97432C2.24991 10.8342 2.25 11.8352 2.25 13H3.75ZM3.77849 10.0257C3.84204 8.17075 4.04907 7.20746 4.56168 6.50191L3.34815 5.62023C2.5463 6.7239 2.34355 8.10087 2.27937 9.97432L3.77849 10.0257ZM3.02893 10.75H20.9711V9.25H3.02893V10.75ZM21.75 13C21.75 11.8352 21.7501 10.8342 21.7206 9.97432L20.2215 10.0257C20.2499 10.8544 20.25 11.8269 20.25 13H21.75ZM21.7206 9.97432C21.6564 8.10087 21.4537 6.7239 20.6518 5.62023L19.4383 6.50191C19.9509 7.20746 20.158 8.17075 20.2215 10.0257L21.7206 9.97432ZM15.75 5V4.02893H14.25V5H15.75ZM15.75 4.02893V2H14.25V4.02893H15.75ZM12 4.75C13.1731 4.75 14.1456 4.75009 14.9743 4.77849L15.0257 3.27937C14.1658 3.24991 13.1648 3.25 12 3.25V4.75ZM14.9743 4.77849C16.8292 4.84204 17.7925 5.04907 18.4981 5.56168L19.3798 4.34815C18.2761 3.5463 16.8991 3.34356 15.0257 3.27937L14.9743 4.77849ZM9.75 5V4.02893H8.25V5H9.75ZM9.75 4.02893V2H8.25V4.02893H9.75ZM12 3.25C10.8352 3.25 9.83424 3.24991 8.97432 3.27937L9.02568 4.77849C9.85445 4.75009 10.8269 4.75 12 4.75V3.25ZM8.97432 3.27937C7.10087 3.34356 5.7239 3.5463 4.62023 4.34815L5.50191 5.56168C6.20746 5.04907 7.17075 4.84204 9.02568 4.77849L8.97432 3.27937Z"
      fill="currentColor"
    />
  </svg>
);
export const heartIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 19.7501C11.8011 19.7499 11.6105 19.6708 11.47 19.5301L4.69998 12.7401C3.78384 11.8054 3.27069 10.5488 3.27069 9.24006C3.27069 7.9313 3.78384 6.6747 4.69998 5.74006C5.62827 4.81186 6.88724 4.29042 8.19998 4.29042C9.51271 4.29042 10.7717 4.81186 11.7 5.74006L12 6.00006L12.28 5.72006C12.739 5.25606 13.2857 4.88801 13.8883 4.63736C14.4909 4.3867 15.1373 4.25845 15.79 4.26006C16.4419 4.25714 17.088 4.38382 17.6905 4.63274C18.2931 4.88167 18.8402 5.24786 19.3 5.71006C20.2161 6.6447 20.7293 7.9013 20.7293 9.21006C20.7293 10.5188 20.2161 11.7754 19.3 12.7101L12.53 19.5001C12.4629 19.5752 12.3815 19.636 12.2904 19.679C12.1993 19.7219 12.1006 19.7461 12 19.7501ZM8.20998 5.75006C7.75581 5.74675 7.30548 5.83342 6.88497 6.00505C6.46447 6.17669 6.08212 6.42989 5.75998 6.75006C5.11085 7.40221 4.74643 8.28491 4.74643 9.20506C4.74643 10.1252 5.11085 11.0079 5.75998 11.6601L12 17.9401L18.23 11.6801C18.5526 11.3578 18.8085 10.9751 18.9832 10.5538C19.1578 10.1326 19.2477 9.68107 19.2477 9.22506C19.2477 8.76905 19.1578 8.31752 18.9832 7.89627C18.8085 7.47503 18.5526 7.09233 18.23 6.77006C17.9104 6.44929 17.5299 6.1956 17.1109 6.02387C16.6919 5.85215 16.2428 5.76586 15.79 5.77006C15.3358 5.76675 14.8855 5.85342 14.465 6.02505C14.0445 6.19669 13.6621 6.44989 13.34 6.77006L12.53 7.58006C12.3869 7.71581 12.1972 7.79149 12 7.79149C11.8028 7.79149 11.613 7.71581 11.47 7.58006L10.66 6.77006C10.3395 6.44628 9.95788 6.18939 9.5373 6.01429C9.11672 5.83919 8.66555 5.74937 8.20998 5.75006Z"
      fill="currentColor"
    />
  </svg>
);
export const imageIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M18 4.25H6C5.27065 4.25 4.57118 4.53973 4.05546 5.05546C3.53973 5.57118 3.25 6.27065 3.25 7V17C3.25 17.7293 3.53973 18.4288 4.05546 18.9445C4.57118 19.4603 5.27065 19.75 6 19.75H18C18.7293 19.75 19.4288 19.4603 19.9445 18.9445C20.4603 18.4288 20.75 17.7293 20.75 17V7C20.75 6.27065 20.4603 5.57118 19.9445 5.05546C19.4288 4.53973 18.7293 4.25 18 4.25ZM6 5.75H18C18.3315 5.75 18.6495 5.8817 18.8839 6.11612C19.1183 6.35054 19.25 6.66848 19.25 7V15.19L16.53 12.47C16.4589 12.394 16.3717 12.3348 16.2748 12.2968C16.178 12.2587 16.0738 12.2427 15.97 12.25C15.865 12.2561 15.7622 12.2831 15.6678 12.3295C15.5733 12.3759 15.4891 12.4406 15.42 12.52L14.13 14.07L9.53 9.47C9.46222 9.39797 9.37993 9.34111 9.28858 9.30319C9.19723 9.26527 9.09887 9.24714 9 9.25C8.89496 9.25611 8.79221 9.28314 8.69776 9.32951C8.60331 9.37587 8.51908 9.44064 8.45 9.52L4.75 13.93V7C4.75 6.66848 4.8817 6.35054 5.11612 6.11612C5.35054 5.8817 5.66848 5.75 6 5.75ZM4.75 17V16.27L9.05 11.11L13.17 15.23L10.65 18.23H6C5.67192 18.23 5.35697 18.1011 5.12311 17.871C4.88926 17.6409 4.75525 17.328 4.75 17ZM18 18.25H12.6L16.05 14.11L19.2 17.26C19.1447 17.538 18.9951 17.7884 18.7764 17.9688C18.5577 18.1492 18.2835 18.2485 18 18.25Z"
      fill="currentColor"
    />
  </svg>
);
export const commentsIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M4.24999 17.3099C4.12892 17.312 4.00915 17.2847 3.9009 17.2305C3.79266 17.1762 3.69916 17.0965 3.62841 16.9982C3.55766 16.9 3.51175 16.786 3.49461 16.6662C3.47747 16.5463 3.48961 16.4241 3.52999 16.3099L4.77999 12.1899C4.52436 11.4876 4.38913 10.7472 4.37999 9.9999C4.37802 9.13731 4.55154 8.28333 4.88999 7.4899C5.30028 6.51274 5.94398 5.65112 6.76468 4.98056C7.58537 4.31 8.55801 3.85097 9.59735 3.6437C10.6367 3.43642 11.711 3.48723 12.7261 3.79167C13.7413 4.09611 14.6662 4.64488 15.42 5.3899C16.0049 5.98413 16.473 6.68291 16.8 7.4499C17.1322 8.24151 17.3033 9.0914 17.3033 9.9499C17.3033 10.8084 17.1322 11.6583 16.8 12.4499C16.473 13.2169 16.0049 13.9157 15.42 14.5099C14.5431 15.3852 13.4337 15.9908 12.2231 16.2549C11.0126 16.519 9.75176 16.4305 8.58999 15.9999L4.46999 17.2799C4.39833 17.2997 4.32434 17.3098 4.24999 17.3099ZM10.84 4.9999C10.1769 4.99798 9.52031 5.13065 8.90999 5.3899C7.72766 5.88887 6.78244 6.82335 6.26999 7.9999C6.01284 8.61261 5.88039 9.27042 5.88039 9.9349C5.88039 10.5994 6.01284 11.2572 6.26999 11.8699C6.32957 12.0347 6.32957 12.2151 6.26999 12.3799L5.34999 15.3799L8.34999 14.4599C8.51477 14.4003 8.69521 14.4003 8.85999 14.4599C10.0743 14.9642 11.4383 14.9699 12.6567 14.4758C13.8752 13.9817 14.85 13.0275 15.37 11.8199C15.6626 11.0719 15.7707 10.2644 15.6852 9.4658C15.5996 8.66717 15.323 7.90091 14.8786 7.23186C14.4342 6.5628 13.8351 6.01066 13.1321 5.62215C12.4292 5.23364 11.6429 5.0202 10.84 4.9999Z"
      fill="currentColor"
    />
    <path
      d="M19.75 20.4998C19.677 20.5096 19.603 20.5096 19.53 20.4998L15.41 19.2498C13.8621 19.8343 12.1484 19.7986 10.6262 19.1502C9.10407 18.5019 7.89098 17.2909 7.23998 15.7698C7.19548 15.6798 7.17003 15.5816 7.16521 15.4813C7.16039 15.381 7.17631 15.2808 7.21198 15.187C7.24764 15.0931 7.30228 15.0076 7.37248 14.9359C7.44269 14.8641 7.52694 14.8076 7.61998 14.7698C7.71046 14.7282 7.80831 14.7051 7.90783 14.7017C8.00736 14.6983 8.10655 14.7148 8.19964 14.7502C8.29272 14.7856 8.37783 14.8391 8.45 14.9077C8.52217 14.9763 8.57995 15.0586 8.61998 15.1498C8.85767 15.7163 9.19653 16.2347 9.61998 16.6798C10.3211 17.3733 11.2117 17.8439 12.1797 18.0325C13.1476 18.2211 14.1497 18.1193 15.06 17.7398C15.2248 17.6802 15.4052 17.6802 15.57 17.7398L18.57 18.6598L17.65 15.6598C17.5904 15.495 17.5904 15.3146 17.65 15.1498C17.9092 14.5395 18.0419 13.8829 18.04 13.2198C18.0423 12.5679 17.9154 11.9221 17.6665 11.3196C17.4176 10.7171 17.0517 10.17 16.59 9.70981C16.3877 9.45416 16.1635 9.2166 15.92 8.99981C15.8325 8.94736 15.7567 8.87762 15.6972 8.79487C15.6376 8.71212 15.5955 8.61809 15.5735 8.51852C15.5515 8.41896 15.55 8.31596 15.5692 8.21581C15.5883 8.11566 15.6277 8.02047 15.6849 7.93605C15.7421 7.85164 15.8159 7.77977 15.9018 7.72483C15.9877 7.6699 16.0839 7.63306 16.1845 7.61657C16.2851 7.60007 16.3881 7.60427 16.487 7.6289C16.5859 7.65353 16.6788 7.69807 16.76 7.75981C17.1177 7.99073 17.4525 8.25526 17.76 8.54981C18.3481 9.14141 18.8166 9.84084 19.14 10.6098C19.4792 11.4065 19.6527 12.2639 19.65 13.1298C19.6479 13.8973 19.5125 14.6586 19.25 15.3798L20.5 19.4998C20.5404 19.614 20.5525 19.7362 20.5354 19.8561C20.5182 19.9759 20.4723 20.0899 20.4016 20.1882C20.3308 20.2864 20.2373 20.3661 20.1291 20.4204C20.0208 20.4746 19.901 20.5019 19.78 20.4998H19.75Z"
      fill="currentColor"
    />
  </svg>
);

export const graphIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M4.5 20.25C4.30189 20.2474 4.11263 20.1676 3.97253 20.0275C3.83244 19.8874 3.75259 19.6981 3.75 19.5V4.5C3.75 4.30109 3.82902 4.11032 3.96967 3.96967C4.11032 3.82902 4.30109 3.75 4.5 3.75C4.69891 3.75 4.88968 3.82902 5.03033 3.96967C5.17098 4.11032 5.25 4.30109 5.25 4.5V19.5C5.24741 19.6981 5.16756 19.8874 5.02747 20.0275C4.88737 20.1676 4.69811 20.2474 4.5 20.25Z"
      fill="currentColor"
    />
    <path
      d="M19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5C3.75 19.3011 3.82902 19.1103 3.96967 18.9697C4.11032 18.829 4.30109 18.75 4.5 18.75H19.5C19.6989 18.75 19.8897 18.829 20.0303 18.9697C20.171 19.1103 20.25 19.3011 20.25 19.5C20.25 19.6989 20.171 19.8897 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25Z"
      fill="currentColor"
    />
    <path
      d="M14 14.7501C13.9015 14.7506 13.8038 14.7313 13.7128 14.6936C13.6218 14.6558 13.5393 14.6002 13.47 14.5301L11 12.0601L8.53003 14.5301C8.38785 14.6626 8.19981 14.7347 8.00551 14.7313C7.81121 14.7278 7.62582 14.6491 7.48841 14.5117C7.35099 14.3743 7.27228 14.1889 7.26885 13.9946C7.26543 13.8003 7.33755 13.6123 7.47003 13.4701L10.47 10.4701C10.6107 10.3296 10.8013 10.2508 11 10.2508C11.1988 10.2508 11.3894 10.3296 11.53 10.4701L14 12.9401L17.47 9.47009C17.6122 9.33761 17.8003 9.26549 17.9946 9.26892C18.1889 9.27234 18.3742 9.35106 18.5117 9.48847C18.6491 9.62588 18.7278 9.81127 18.7312 10.0056C18.7346 10.1999 18.6625 10.3879 18.53 10.5301L14.53 14.5301C14.4608 14.6002 14.3782 14.6558 14.2872 14.6936C14.1962 14.7313 14.0986 14.7506 14 14.7501Z"
      fill="currentColor"
    />
    <path
      d="M18.5 13.84C18.3019 13.8374 18.1126 13.7576 17.9725 13.6175C17.8324 13.4774 17.7526 13.2881 17.75 13.09V10.25H15C14.8011 10.25 14.6103 10.171 14.4697 10.0303C14.329 9.88968 14.25 9.69891 14.25 9.5C14.25 9.30109 14.329 9.11032 14.4697 8.96967C14.6103 8.82902 14.8011 8.75 15 8.75H18.5C18.6981 8.75259 18.8874 8.83244 19.0275 8.97253C19.1676 9.11263 19.2474 9.30189 19.25 9.5V13.09C19.2474 13.2881 19.1676 13.4774 19.0275 13.6175C18.8874 13.7576 18.6981 13.8374 18.5 13.84Z"
      fill="currentColor"
    />
  </svg>
);
export const instagramfilled = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <g clipPath="url(#clip0_223_23867)">
      <path
        d="M7.94085 0H2.05915C0.921912 0 0 0.921912 0 2.05915V7.94085C0 9.07809 0.921912 10 2.05915 10H7.94085C9.07809 10 10 9.07809 10 7.94085V2.05915C10 0.921912 9.07809 0 7.94085 0Z"
        fill="#9FA89E"
      />
      <path
        d="M7.18518 8.28206H2.81508C2.21012 8.28206 1.71811 7.79005 1.71811 7.18509V2.81499C1.71811 2.21002 2.21012 1.71802 2.81508 1.71802H7.18518C7.79014 1.71802 8.28215 2.21002 8.28215 2.81499V7.18509C8.28215 7.79005 7.79014 8.28206 7.18518 8.28206ZM2.81508 2.07685C2.40827 2.07685 2.07721 2.40791 2.07721 2.81472V7.18482C2.07721 7.59163 2.40827 7.92269 2.81508 7.92269H7.18518C7.59199 7.92269 7.92305 7.59163 7.92305 7.18482V2.81499C7.92305 2.40817 7.59199 2.07712 7.18518 2.07712H2.81508V2.07685Z"
        fill="white"
      />
      <path
        d="M5.00012 6.68421C4.55017 6.68421 4.12745 6.50897 3.80933 6.19085C3.49121 5.87273 3.31598 5.44974 3.31598 5.00006C3.31598 4.55038 3.49121 4.12739 3.80933 3.80927C4.12745 3.49115 4.55044 3.31592 5.00012 3.31592C5.4498 3.31592 5.8728 3.49115 6.19091 3.80927C6.50903 4.12739 6.68427 4.55038 6.68427 5.00006C6.68427 5.44974 6.50903 5.87273 6.19091 6.19085C5.8728 6.50897 5.4498 6.68421 5.00012 6.68421ZM5.00012 3.67502C4.26953 3.67502 3.67508 4.26947 3.67508 5.00006C3.67508 5.73066 4.26953 6.32511 5.00012 6.32511C5.73072 6.32511 6.32517 5.73066 6.32517 5.00006C6.32517 4.26947 5.73072 3.67502 5.00012 3.67502Z"
        fill="white"
      />
      <path
        d="M7.40441 2.70378C7.44541 2.53003 7.33781 2.35594 7.16406 2.31493C6.99031 2.27392 6.81622 2.38153 6.77521 2.55528C6.7342 2.72902 6.84181 2.90312 7.01556 2.94412C7.1893 2.98513 7.3634 2.87753 7.40441 2.70378Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_223_23867">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const facebookFilled = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <g clipPath="url(#clip0_223_23879)">
      <path
        d="M7.94085 0H2.05915C0.921912 0 0 0.921912 0 2.05915V7.94085C0 9.07809 0.921912 10 2.05915 10H7.94085C9.07809 10 10 9.07809 10 7.94085V2.05915C10 0.921912 9.07809 0 7.94085 0Z"
        fill="#9FA89E"
      />
      <path
        d="M5.48972 5.59381V8.64533H4.08649V5.59381H2.92212V4.35692H4.08649V3.90508C4.08649 2.23307 4.78366 1.35474 6.26156 1.35474C6.71421 1.35474 6.82771 1.42699 7.07654 1.48657V2.71079C6.79778 2.66118 6.71987 2.63611 6.43114 2.63611C6.08768 2.63611 5.90624 2.73209 5.73936 2.9235C5.57248 3.11518 5.48918 3.44731 5.48918 3.91991V4.35692H7.07762L6.65086 5.59381H5.48918H5.48972Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_223_23879">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const systemIcon = (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.00008 1.40625C2.98756 1.40625 2.16675 2.17576 2.16675 3.125C2.16675 4.07424 2.98756 4.84375 4.00008 4.84375C5.0126 4.84375 5.83341 4.07424 5.83341 3.125C5.83341 2.17576 5.0126 1.40625 4.00008 1.40625ZM3.16675 3.125C3.16675 2.69353 3.53984 2.34375 4.00008 2.34375C4.46032 2.34375 4.83341 2.69353 4.83341 3.125C4.83341 3.55647 4.46032 3.90625 4.00008 3.90625C3.53984 3.90625 3.16675 3.55647 3.16675 3.125Z"
      fill="currentColor"
    />
    <path
      d="M8.00008 2.65625C7.72394 2.65625 7.50008 2.86612 7.50008 3.125C7.50008 3.38388 7.72394 3.59375 8.00008 3.59375L13.3334 3.59375C13.6096 3.59375 13.8334 3.38388 13.8334 3.125C13.8334 2.86612 13.6096 2.65625 13.3334 2.65625L8.00008 2.65625Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0001 5.78125C10.9876 5.78125 10.1667 6.55076 10.1667 7.5C10.1667 8.44924 10.9876 9.21875 12.0001 9.21875C13.0126 9.21875 13.8334 8.44924 13.8334 7.5C13.8334 6.55076 13.0126 5.78125 12.0001 5.78125ZM11.1667 7.5C11.1667 7.06853 11.5398 6.71875 12.0001 6.71875C12.4603 6.71875 12.8334 7.06853 12.8334 7.5C12.8334 7.93147 12.4603 8.28125 12.0001 8.28125C11.5398 8.28125 11.1667 7.93147 11.1667 7.5Z"
      fill="currentColor"
    />
    <path
      d="M2.66675 7.03125C2.39061 7.03125 2.16675 7.24112 2.16675 7.5C2.16675 7.75888 2.39061 7.96875 2.66675 7.96875L8.00008 7.96875C8.27622 7.96875 8.50008 7.75888 8.50008 7.5C8.50008 7.24112 8.27622 7.03125 8.00008 7.03125L2.66675 7.03125Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.00008 10.1562C2.98756 10.1562 2.16675 10.9258 2.16675 11.875C2.16675 12.8242 2.98756 13.5938 4.00008 13.5938C5.0126 13.5938 5.83341 12.8242 5.83341 11.875C5.83341 10.9258 5.0126 10.1562 4.00008 10.1562ZM3.16675 11.875C3.16675 11.4435 3.53984 11.0938 4.00008 11.0938C4.46032 11.0938 4.83341 11.4435 4.83341 11.875C4.83341 12.3065 4.46032 12.6562 4.00008 12.6562C3.53984 12.6562 3.16675 12.3065 3.16675 11.875Z"
      fill="currentColor"
    />
    <path
      d="M8.00008 11.4062C7.72394 11.4062 7.50008 11.6161 7.50008 11.875C7.50008 12.1339 7.72394 12.3438 8.00008 12.3438H13.3334C13.6096 12.3438 13.8334 12.1339 13.8334 11.875C13.8334 11.6161 13.6096 11.4062 13.3334 11.4062H8.00008Z"
      fill="currentColor"
    />
  </svg>
);
export const filterIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M13.9999 20.5H9.99991C9.8018 20.4974 9.61253 20.4176 9.47244 20.2775C9.33234 20.1374 9.2525 19.9481 9.24991 19.75V12L3.89991 4.69C3.81535 4.58007 3.76385 4.44832 3.75146 4.31018C3.73906 4.17204 3.76627 4.03323 3.8299 3.91C3.89365 3.78712 3.98975 3.68399 4.10783 3.61173C4.22591 3.53947 4.36148 3.50084 4.4999 3.5H19.4999C19.6383 3.50084 19.7739 3.53947 19.892 3.61173C20.0101 3.68399 20.1062 3.78712 20.1699 3.91C20.2335 4.03323 20.2607 4.17204 20.2484 4.31018C20.236 4.44832 20.1845 4.58007 20.0999 4.69L14.7499 12V19.75C14.7473 19.9481 14.6675 20.1374 14.5274 20.2775C14.3873 20.4176 14.198 20.4974 13.9999 20.5ZM10.7499 19H13.2499V11.75C13.2491 11.5907 13.3019 11.4357 13.3999 11.31L17.9999 5H5.99991L10.6199 11.31C10.7179 11.4357 10.7707 11.5907 10.7699 11.75L10.7499 19Z"
      fill="currentColor"
    />
  </svg>
);
export const shareIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M17.5 14.25C16.9877 14.2518 16.4831 14.3751 16.0276 14.6098C15.5722 14.8445 15.1789 15.1838 14.88 15.6L9.59 13C9.6931 12.6765 9.74704 12.3394 9.75 12C9.74704 11.6605 9.6931 11.3234 9.59 11L14.88 8.39996C15.3362 9.01882 15.9982 9.45467 16.7469 9.62915C17.4957 9.80363 18.2821 9.7053 18.9649 9.35185C19.6477 8.99839 20.182 8.41299 20.4717 7.70086C20.7615 6.98874 20.7878 6.19661 20.5458 5.46685C20.3038 4.7371 19.8095 4.11758 19.1517 3.71967C18.4938 3.32177 17.7156 3.17156 16.9569 3.29605C16.1982 3.42055 15.5089 3.81158 15.0127 4.39886C14.5165 4.98614 14.2461 5.73115 14.25 6.49996C14.2524 6.66775 14.2691 6.83503 14.3 6.99996L8.83 9.74996C8.53061 9.43287 8.16938 9.18052 7.76862 9.00852C7.36787 8.83653 6.9361 8.74853 6.5 8.74996C5.63805 8.74996 4.8114 9.09237 4.2019 9.70187C3.59241 10.3114 3.25 11.138 3.25 12C3.25 12.8619 3.59241 13.6886 4.2019 14.2981C4.8114 14.9076 5.63805 15.25 6.5 15.25C6.9361 15.2514 7.36787 15.1634 7.76862 14.9914C8.16938 14.8194 8.53061 14.5671 8.83 14.25L14.3 17C14.2685 17.1682 14.2518 17.3388 14.25 17.51C14.25 18.1528 14.4406 18.7811 14.7977 19.3156C15.1548 19.85 15.6624 20.2666 16.2563 20.5126C16.8501 20.7586 17.5036 20.8229 18.134 20.6975C18.7645 20.5721 19.3436 20.2626 19.7981 19.8081C20.2526 19.3535 20.5621 18.7744 20.6876 18.144C20.813 17.5136 20.7486 16.8601 20.5026 16.2662C20.2566 15.6724 19.8401 15.1648 19.3056 14.8077C18.7711 14.4506 18.1428 14.26 17.5 14.26V14.25ZM17.5 4.74996C17.8461 4.74996 18.1845 4.8526 18.4722 5.04489C18.76 5.23718 18.9843 5.5105 19.1168 5.83027C19.2492 6.15004 19.2839 6.50191 19.2164 6.84137C19.1488 7.18084 18.9822 7.49266 18.7374 7.7374C18.4927 7.98214 18.1809 8.14881 17.8414 8.21634C17.5019 8.28386 17.1501 8.24921 16.8303 8.11675C16.5105 7.9843 16.2372 7.76 16.0449 7.47221C15.8526 7.18443 15.75 6.84608 15.75 6.49996C15.7526 6.03664 15.9378 5.59305 16.2655 5.26543C16.5931 4.93781 17.0367 4.75259 17.5 4.74996ZM6.5 13.75C6.15388 13.75 5.81554 13.6473 5.52775 13.455C5.23997 13.2627 5.01566 12.9894 4.88321 12.6697C4.75076 12.3499 4.7161 11.998 4.78363 11.6586C4.85115 11.3191 5.01782 11.0073 5.26256 10.7625C5.50731 10.5178 5.81912 10.3511 6.15859 10.2836C6.49806 10.2161 6.84993 10.2507 7.1697 10.3832C7.48947 10.5156 7.76278 10.7399 7.95507 11.0277C8.14736 11.3155 8.25 11.6538 8.25 12C8.24738 12.4633 8.06216 12.9069 7.73454 13.2345C7.40691 13.5621 6.96332 13.7473 6.5 13.75ZM17.5 19.25C17.1539 19.25 16.8155 19.1473 16.5278 18.955C16.24 18.7627 16.0157 18.4894 15.8832 18.1697C15.7508 17.8499 15.7161 17.498 15.7836 17.1586C15.8511 16.8191 16.0178 16.5073 16.2626 16.2625C16.5073 16.0178 16.8191 15.8511 17.1586 15.7836C17.4981 15.7161 17.8499 15.7507 18.1697 15.8832C18.4895 16.0156 18.7628 16.2399 18.9551 16.5277C19.1474 16.8155 19.25 17.1538 19.25 17.5C19.2474 17.9633 19.0622 18.4069 18.7345 18.7345C18.4069 19.0621 17.9633 19.2473 17.5 19.25Z"
      fill="currentColor"
    />
  </svg>
);
export const shareSecondIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    enable-background="new 0 0 24 24"
    space="preserve"
  >
    <image
      overflow="visible"
      width="25"
      height="25"
      href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAABE0lEQVR4nO3UsSuFURzG8Y8rw5VsUohJqbuYWZVN6u6SKHURKTab2eBKWZTRIPkLTCYlBjYsJCXFYLx66wy3m3jf1z2D8q2znJ7ze/qd33MO//yTkWkURaaGCwzENlnFA0ZjmiSM4xmLmkALSihjoc4kYRDX2EFbnuKlcPgJVzjAFlYadJ04wSm60hZvRxX3WEp5sIBN3GH4J3F3SE41mGVlD7ffCTpwieUcxQtpO9nHdsNea5jNBCpYx3zemYyENoshTZM4whsecYZj7P4mXUnBWYzhPKzk2oa+0Na/kyR5c1LQixdshESVQzdNffEVfISh96TQ10KnfTJwiNcMH95Mnl/4Bmsi847+2CZTsQ38eT4Bui47yuCZUlAAAAAASUVORK5CYII="
      transform="matrix(0.698 0 0 0.6192 3.2749 4.2593)"
    ></image>
  </svg>
);
export const engagementIcon = (
  <svg
    version="1.0"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    enable-background="new 0 0 24 24"
    space="preserve"
  >
    <image
      overflow="visible"
      width="50"
      height="50"
      href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD
p0lEQVR4nO2ZWaiNURTHf1y5GS73EhnKEEqGPIiQoTwQCckUCpEHXGP3wQPyYJYHJcOLMaUQHiiR
qQy5ZrnCg8yum3uNmT/t+n/aHWf4zjn77HvT/dd+ON/Z67/WOnt9a+21DtSiFrXwjY5ACXAGKAM+
AB+Bu8AmoD01HC2AvcBvIEiyPgPLgKFAITUMvYC3MrQK2A6MBDoBjYEmQH/gQByntgLNqAHoAryR
YceB1in2jwU2A4eBL5J7JKerDXWACzLmCFAvTXlzEickfxPIp5owRUa8UPhkAmP8HfEsoppwSQbM
zJJnhBVidfCMrlL+DmiQJVdd4Jn4euIZxVK8xxHfbvEZXq84JMXTHfEtFt8OPKNMirs74psgvtN4
hEmz34EfDlNmPzliMpg3tJTSlw4524nzOR7RTUrNRdD1j/MGjxgopecdcjYXZwUeMUZKjzrkLBJn
JR4xVUr3OeQ0V5xA/Ys3zJbSnQ45m4rzPdVQ1bfkwJEqPKJESjc65DTdondH1kmpaVldoUCcptny
hn1SOs0hZ57VAjfCE85K4RDHvOXi7YAHmGHCJ+CXqnEufqBJeMAaKTuZw7R+Fw/YZN1SJ6oiZwsz
eZlltQZX8YBWwGPrxTQhdk+N1nr1FaZ1TYbhwCrgoGRjh3rXgNu6rphW+gGwCxivpOD0PVkCnNP7
EjtNHJREtkec/W9V0YMI6yEwmhw1WZ01CamIkM36WFeREQqrZTrZAHgCLAX6au5VpIHEQuC+9vzW
6TufuJhQ2iAl5SpuidDQmkxu1smGIboyxZDP6JkPfJXMapdO9FNfEhozLoLMKOCbFS7mF56s7/J1
l7uisDXrshyorz1DLfmswqy+poyXLWNea3AdFYOtcFqrZ22BW0nejxtAG+2daw31Qgcjw4TMcis0
zHqlZ+b2mg4GSP6pTsGs0IkyNW8FWmOVucx312V4nupNEDEK/sZmsXWFCKR0RhZTlK3iWaHPCywn
4v1vUmg5My9mFrY/aud2ynLAxO4wssc18ZkshopgoJNIhHHaY0LaTuUmmyVFA0tBuYqdK7wWbzjF
N3/PBTEZr3eKdrhJ1K5ym5XbzX+DLhFW87AWhCduI974NHZfPLl/pu0/lVmSVepMkcqgggSDiLQd
CW+5x8gNUhk0J4GBaTsSvowmM+UCqQwqtZ6VpiH3DyojXuKyXakMCnQ6GTtysYY48iEmk6XtSK4R
1aDtGcp5Q6oTSlRLosp5Q6YGBf+1I38AvRewTVZctZYAAAAASUVORK5CYII="
      transform="matrix(0.349 0 0 0.311 3.2749 4.2246)"
    ></image>
  </svg>
);
export const commentSecondIcon = (
  <svg
    version="1.0"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    enable-background="new 0 0 24 24"
    space="preserve"
  >
    <g id="surface2">
      <g transform="matrix(0.9999,0,0,0.9999,0,0)">
        <path fill="none" enable-background="new    " d="z" />
      </g>
    </g>
    <image
      overflow="visible"
      width="24"
      height="24"
      href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAKT2lDQ1BQaG90b3Nob3AgSUNDIHBy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"
      transform="matrix(0.7271 0 0 0.645 3.2744 4.2598)"
    ></image>
  </svg>
);

export const mailIcon = (
  <svg width="24" height="20" viewBox="0 0 24 20" fill="none">
    <path
      d="M19 4.25H5C4.53668 4.25263 4.09309 4.43784 3.76546 4.76546C3.43784 5.09309 3.25263 5.53668 3.25 6V18C3.25263 18.4633 3.43784 18.9069 3.76546 19.2345C4.09309 19.5622 4.53668 19.7474 5 19.75H19C19.4633 19.7474 19.9069 19.5622 20.2345 19.2345C20.5622 18.9069 20.7474 18.4633 20.75 18V6C20.7474 5.53668 20.5622 5.09309 20.2345 4.76546C19.9069 4.43784 19.4633 4.25263 19 4.25ZM5 5.75H19C19.0663 5.75 19.1299 5.77634 19.1768 5.82322C19.2237 5.87011 19.25 5.9337 19.25 6V7.54L12 11.16L4.75 7.54V6C4.75 5.9337 4.77634 5.87011 4.82322 5.82322C4.87011 5.77634 4.9337 5.75 5 5.75ZM19 18.25H5C4.9337 18.25 4.87011 18.2237 4.82322 18.1768C4.77634 18.1299 4.75 18.0663 4.75 18V9.21L11.66 12.67C11.7656 12.7228 11.882 12.7503 12 12.7503C12.118 12.7503 12.2344 12.7228 12.34 12.67L19.25 9.21V18C19.25 18.0663 19.2237 18.1299 19.1768 18.1768C19.1299 18.2237 19.0663 18.25 19 18.25Z"
      fill="black"
    />
  </svg>
);
export const chevronBottom2 = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.35147 8.75147C6.8201 8.28284 7.5799 8.28284 8.04853 8.75147L12 12.7029L15.9515 8.75147C16.4201 8.28284 17.1799 8.28284 17.6485 8.75147C18.1172 9.22009 18.1172 9.97989 17.6485 10.4485L12.8485 15.2485C12.3799 15.7172 11.6201 15.7172 11.1515 15.2485L6.35147 10.4485C5.88284 9.97989 5.88284 9.22009 6.35147 8.75147Z"
      fill="currentColor"
    />
  </svg>
);
export const pencilIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clipRule="evenodd"
      d="M14.0858 5.49997C14.8668 4.71892 16.1332 4.71892 16.9142 5.49997L18.5 7.08576C19.281 7.86681 19.281 9.13314 18.5 9.91418L9.41421 19H5V14.5858L14.0858 5.49997ZM7 15.4142V17H8.58579L17.0858 8.49997L15.5 6.91418L7 15.4142Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clipRule="evenodd"
      d="M16.1464 10.8535L13.1464 7.85352L13.8536 7.14642L16.8536 10.1464L16.1464 10.8535Z"
      fill="black"
    />
  </svg>
);

export const reset = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clipRule="evenodd"
      d="M11.8422 6C9.04388 6 6.70444 7.81023 5.94456 10.2706L7.82396 9.35164L8.7025 11.1484L4.43642 13.2343L1.24805 9.59663L2.7521 8.27837L4.01871 9.72348C5.02066 6.40376 8.15776 4 11.8422 4C16.3265 4 20.0001 7.56081 20.0001 12C20.0001 16.4392 16.3265 20 11.8422 20C9.76291 20 7.67587 19.2238 6.08161 17.6647L7.47996 16.2348C8.68103 17.4094 10.2577 18 11.8422 18C15.2642 18 18.0001 15.2928 18.0001 12C18.0001 8.7072 15.2642 6 11.8422 6Z"
      fill="black"
    />
  </svg>
);

export const tiktok = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    version="1.1"
  >
    <g id="surface1">
      <path
        style={{
          stroke: "none",
          "fill-rule": "nonzero",
          fill: "rgb(62.352941%,65.882353%,61.960784%)",
          "fill-opacity": "1",
        }}
        d="M 1.25 0 L 8.75 0 C 9.441406 0 10 0.558594 10 1.25 L 10 8.75 C 10 9.441406 9.441406 10 8.75 10 L 1.25 10 C 0.558594 10 0 9.441406 0 8.75 L 0 1.25 C 0 0.558594 0.558594 0 1.25 0 Z M 1.25 0 "
      />
      <path
        style={{
          stroke: "stroke",
          "fill-rule": "nonzero",
          fill: "rgb(100%,100%,100%)",
          "fill-opacity": "1",
        }}
        d="M 7.128906 2.832031 C 6.753906 2.585938 6.484375 2.195312 6.398438 1.738281 C 6.378906 1.640625 6.371094 1.539062 6.371094 1.433594 L 5.171875 1.433594 L 5.171875 6.234375 C 5.148438 6.773438 4.707031 7.203125 4.164062 7.203125 C 3.996094 7.203125 3.839844 7.164062 3.699219 7.089844 C 3.378906 6.921875 3.160156 6.585938 3.160156 6.199219 C 3.160156 5.644531 3.609375 5.191406 4.164062 5.191406 C 4.269531 5.191406 4.367188 5.207031 4.460938 5.238281 L 4.460938 4.015625 C 4.367188 4 4.265625 3.992188 4.164062 3.992188 C 2.949219 3.992188 1.960938 4.980469 1.960938 6.199219 C 1.960938 6.945312 2.332031 7.605469 2.902344 8.003906 C 3.257812 8.253906 3.695312 8.402344 4.164062 8.402344 C 5.382812 8.402344 6.371094 7.414062 6.371094 6.199219 L 6.371094 3.761719 C 6.839844 4.101562 7.414062 4.300781 8.035156 4.300781 L 8.035156 3.101562 C 7.703125 3.101562 7.390625 3 7.128906 2.832031 Z M 7.128906 2.832031 "
      />
    </g>
  </svg>
);
export const prime = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.36 11.33L14.26 11.08L15.12 12.3V16.09L18.05 13.65V9.5L16.7 9.98L15.36 11.33Z"
      fill="black"
    />
    <path
      d="M8.51996 11.33L7.16996 9.98L5.82996 9.5V13.65L8.75996 16.09V12.3L9.61996 11.08L8.51996 11.33Z"
      fill="black"
    />
    <path
      d="M13.16 11.45H10.72L10.11 11.08L9.13 12.55V18.05L9.86 19.14L10.72 20H13.16L14.02 19.14L14.75 18.05V12.55L13.77 11.08L13.16 11.45Z"
      fill="black"
    />
    <path d="M15.12 18.41L16.7 16.82V15.24L15.12 16.58V18.41Z" fill="black" />
    <path
      d="M7.16992 16.82L8.75992 18.41V16.58L7.16992 15.24V16.82Z"
      fill="black"
    />
    <path
      d="M11.08 10.96H11.7V4H10.35L9.37997 6.31L4.96997 5.95L5.70997 9.01L10.96 10.96H11.08Z"
      fill="black"
    />
    <path
      d="M14.4999 6.31L13.5299 4H12.1799V11H12.9999L18.2499 9L18.9999 6L14.4999 6.31Z"
      fill="black"
    />
    <path d="M17.32 5.71L15.6 4H13.89L14.75 5.95L17.32 5.71Z" fill="black" />
    <path
      d="M9.97994 4H8.26994L6.55994 5.71L9.12994 5.95L9.97994 4Z"
      fill="black"
    />
  </svg>
);

export const externalLink = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
  >
    <g id="surface1">
      <path
        style={{
          stroke: "none",
          "fill-rule": "nonzero",
          fill: "rgb(87.058824%,100%,92.941176%)",
          "fill-opacity": "1",
        }}
        d="M 10.5 12.105469 L 3.5 12.105469 C 3.074219 12.105469 2.667969 11.933594 2.367188 11.632812 C 2.066406 11.332031 1.894531 10.925781 1.894531 10.5 L 1.894531 3.5 C 1.894531 3.074219 2.066406 2.667969 2.367188 2.367188 C 2.667969 2.066406 3.074219 1.894531 3.5 1.894531 L 7 1.894531 C 7.117188 1.894531 7.226562 1.941406 7.308594 2.023438 C 7.390625 2.105469 7.4375 2.21875 7.4375 2.332031 C 7.4375 2.449219 7.390625 2.5625 7.308594 2.644531 C 7.226562 2.726562 7.117188 2.769531 7 2.769531 L 3.5 2.769531 C 3.304688 2.769531 3.121094 2.847656 2.984375 2.984375 C 2.847656 3.121094 2.769531 3.304688 2.769531 3.5 L 2.769531 10.5 C 2.769531 10.695312 2.847656 10.878906 2.984375 11.015625 C 3.121094 11.152344 3.304688 11.230469 3.5 11.230469 L 10.5 11.230469 C 10.695312 11.230469 10.878906 11.152344 11.015625 11.015625 C 11.152344 10.878906 11.230469 10.695312 11.230469 10.5 L 11.230469 7 C 11.230469 6.882812 11.273438 6.773438 11.355469 6.691406 C 11.4375 6.609375 11.550781 6.5625 11.667969 6.5625 C 11.78125 6.5625 11.894531 6.609375 11.976562 6.691406 C 12.058594 6.773438 12.105469 6.882812 12.105469 7 L 12.105469 10.5 C 12.105469 10.925781 11.933594 11.332031 11.632812 11.632812 C 11.332031 11.933594 10.925781 12.105469 10.5 12.105469 Z M 10.5 12.105469 "
      />
      <path
        style={{
          stroke: "none",
          "fill-rule": "nonzero",
          fill: "rgb(87.058824%,100%,92.941176%)",
          "fill-opacity": "1",
        }}
        d="M 11.667969 5.105469 C 11.550781 5.101562 11.441406 5.054688 11.359375 4.972656 C 11.277344 4.894531 11.230469 4.78125 11.230469 4.667969 L 11.230469 2.769531 L 9.332031 2.769531 C 9.21875 2.769531 9.105469 2.726562 9.023438 2.644531 C 8.941406 2.5625 8.894531 2.449219 8.894531 2.332031 C 8.894531 2.21875 8.941406 2.105469 9.023438 2.023438 C 9.105469 1.941406 9.21875 1.894531 9.332031 1.894531 L 11.667969 1.894531 C 11.78125 1.898438 11.894531 1.945312 11.972656 2.027344 C 12.054688 2.105469 12.101562 2.21875 12.105469 2.332031 L 12.105469 4.667969 C 12.101562 4.78125 12.054688 4.894531 11.972656 4.972656 C 11.894531 5.054688 11.78125 5.101562 11.667969 5.105469 Z M 11.667969 5.105469 "
      />
      <path
        style={{
          stroke: "none",
          "fill-rule": "nonzero",
          fill: "rgb(87.058824%,100%,92.941176%)",
          "fill-opacity": "1",
        }}
        d="M 7.875 6.5625 C 7.761719 6.554688 7.65625 6.5 7.582031 6.417969 C 7.511719 6.335938 7.472656 6.234375 7.472656 6.125 C 7.472656 6.015625 7.511719 5.914062 7.582031 5.832031 L 11.375 2.042969 C 11.414062 2 11.464844 1.964844 11.515625 1.941406 C 11.570312 1.917969 11.628906 1.902344 11.6875 1.902344 C 11.746094 1.902344 11.804688 1.914062 11.859375 1.933594 C 11.914062 1.957031 11.960938 1.988281 12.003906 2.03125 C 12.046875 2.070312 12.078125 2.121094 12.101562 2.175781 C 12.121094 2.230469 12.132812 2.289062 12.132812 2.347656 C 12.132812 2.40625 12.117188 2.464844 12.09375 2.519531 C 12.070312 2.570312 12.035156 2.621094 11.992188 2.660156 L 8.167969 6.417969 C 8.09375 6.5 7.988281 6.554688 7.875 6.5625 Z M 7.875 6.5625 "
      />
    </g>
  </svg>
);
export const externalLinkBlack = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
  >
    <g id="surface1">
      <path
        style={{
          stroke: "none",
          "fill-rule": "nonzero",
          fill: "rgb(0%,0%,06%)",
          "fill-opacity": "1",
        }}
        d="M 10.5 12.105469 L 3.5 12.105469 C 3.074219 12.105469 2.667969 11.933594 2.367188 11.632812 C 2.066406 11.332031 1.894531 10.925781 1.894531 10.5 L 1.894531 3.5 C 1.894531 3.074219 2.066406 2.667969 2.367188 2.367188 C 2.667969 2.066406 3.074219 1.894531 3.5 1.894531 L 7 1.894531 C 7.117188 1.894531 7.226562 1.941406 7.308594 2.023438 C 7.390625 2.105469 7.4375 2.21875 7.4375 2.332031 C 7.4375 2.449219 7.390625 2.5625 7.308594 2.644531 C 7.226562 2.726562 7.117188 2.769531 7 2.769531 L 3.5 2.769531 C 3.304688 2.769531 3.121094 2.847656 2.984375 2.984375 C 2.847656 3.121094 2.769531 3.304688 2.769531 3.5 L 2.769531 10.5 C 2.769531 10.695312 2.847656 10.878906 2.984375 11.015625 C 3.121094 11.152344 3.304688 11.230469 3.5 11.230469 L 10.5 11.230469 C 10.695312 11.230469 10.878906 11.152344 11.015625 11.015625 C 11.152344 10.878906 11.230469 10.695312 11.230469 10.5 L 11.230469 7 C 11.230469 6.882812 11.273438 6.773438 11.355469 6.691406 C 11.4375 6.609375 11.550781 6.5625 11.667969 6.5625 C 11.78125 6.5625 11.894531 6.609375 11.976562 6.691406 C 12.058594 6.773438 12.105469 6.882812 12.105469 7 L 12.105469 10.5 C 12.105469 10.925781 11.933594 11.332031 11.632812 11.632812 C 11.332031 11.933594 10.925781 12.105469 10.5 12.105469 Z M 10.5 12.105469 "
      />
      <path
        style={{
          stroke: "none",
          "fill-rule": "nonzero",
          fill: "rgb(0%,0%,0%)",
          "fill-opacity": "1",
        }}
        d="M 11.667969 5.105469 C 11.550781 5.101562 11.441406 5.054688 11.359375 4.972656 C 11.277344 4.894531 11.230469 4.78125 11.230469 4.667969 L 11.230469 2.769531 L 9.332031 2.769531 C 9.21875 2.769531 9.105469 2.726562 9.023438 2.644531 C 8.941406 2.5625 8.894531 2.449219 8.894531 2.332031 C 8.894531 2.21875 8.941406 2.105469 9.023438 2.023438 C 9.105469 1.941406 9.21875 1.894531 9.332031 1.894531 L 11.667969 1.894531 C 11.78125 1.898438 11.894531 1.945312 11.972656 2.027344 C 12.054688 2.105469 12.101562 2.21875 12.105469 2.332031 L 12.105469 4.667969 C 12.101562 4.78125 12.054688 4.894531 11.972656 4.972656 C 11.894531 5.054688 11.78125 5.101562 11.667969 5.105469 Z M 11.667969 5.105469 "
      />
      <path
        style={{
          stroke: "none",
          "fill-rule": "nonzero",
          fill: "rgb0%,0%,0%)",
          "fill-opacity": "1",
        }}
        d="M 7.875 6.5625 C 7.761719 6.554688 7.65625 6.5 7.582031 6.417969 C 7.511719 6.335938 7.472656 6.234375 7.472656 6.125 C 7.472656 6.015625 7.511719 5.914062 7.582031 5.832031 L 11.375 2.042969 C 11.414062 2 11.464844 1.964844 11.515625 1.941406 C 11.570312 1.917969 11.628906 1.902344 11.6875 1.902344 C 11.746094 1.902344 11.804688 1.914062 11.859375 1.933594 C 11.914062 1.957031 11.960938 1.988281 12.003906 2.03125 C 12.046875 2.070312 12.078125 2.121094 12.101562 2.175781 C 12.121094 2.230469 12.132812 2.289062 12.132812 2.347656 C 12.132812 2.40625 12.117188 2.464844 12.09375 2.519531 C 12.070312 2.570312 12.035156 2.621094 11.992188 2.660156 L 8.167969 6.417969 C 8.09375 6.5 7.988281 6.554688 7.875 6.5625 Z M 7.875 6.5625 "
      />
    </g>
  </svg>
);
export const exclamation_mark = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 39 39"
    enable-background="new 0 0 39 39"
    space="preserve"
  >
    <circle fill="#BDFFC2" cx="19.5" cy="19.5" r="19.5" />
    <path
      id="exclamation_mark"
      d="M16.3,30.7c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.3,1.5,3.3,3.2c0,1.8-1.5,3.2-3.3,3.2
	C17.7,33.9,16.3,32.5,16.3,30.7z M18.4,23.2l-1.6-10.7c-0.2-1.6-0.5-3.1-0.5-4.3c0-1.8,1.2-3,3.2-3s3.2,1.3,3.2,3
	c0,1.2-0.3,2.8-0.5,4.4l-1.5,10.6c-0.3,1.5-0.7,1.7-1.1,1.7S18.6,24.7,18.4,23.2z"
    />
  </svg>
);

export const youtube = (
  <svg
    id="Layer_1"
    width="15"
    height="18"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600.81 420.57"
  >
    <defs>
      <style>
        {`
          .cls-1 {
            fill: #5e5e5e;
          }
          .cls-1, .cls-2 {
            strokeWidth: 0;
          }
          .cls-2 {
            fill: #fff;
          }
        `}
      </style>
    </defs>
    <path
      className="cls-1"
      d="m588.26,65.67c-6.91-25.85-27.27-46.21-53.12-53.12C488.29,0,300.41,0,300.41,0c0,0-187.88,0-234.73,12.55-25.85,6.91-46.21,27.27-53.12,53.12C0,112.53,0,210.28,0,210.28c0,0,0,97.76,12.55,144.61,6.91,25.85,27.27,46.21,53.12,53.12,46.85,12.55,234.73,12.55,234.73,12.55,0,0,187.88,0,234.73-12.55,25.85-6.91,46.21-27.27,53.12-53.12,12.55-46.85,12.55-144.61,12.55-144.61,0,0,0-97.76-12.55-144.61Z"
    />
    <polygon
      className="cls-2"
      points="240.33 300.41 396.41 210.29 240.33 120.16 240.33 300.41"
    />
  </svg>
);
export const assignToListIcon = (
  <svg
    className="heart-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path>
  </svg>
);
export const assignToListIconRed = (
  <svg
    className="heart-icon active"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path>
  </svg>
);

export const tickSymbol = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#08a708"
    className="bi bi-check-circle-fill"
    viewBox="0 0 25 25"
    id="Check-Circle-Fill--Streamline-Bootstrap.svg"
    height="16"
    width="15"
  >
    <desc>Check Circle Fill Streamline Icon: https://streamlinehq.com</desc>
    <path
      d="M25 12.5A12.5 12.5 0 1 1 0 12.5a12.5 12.5 0 0 1 25 0m-6.203125 -4.734375a1.171875 1.171875 0 0 0 -1.6875 0.034374999999999996L11.6828125 14.714062499999999 8.412500000000001 11.442187500000001a1.171875 1.171875 0 0 0 -1.65625 1.65625L10.890625 17.234375a1.171875 1.171875 0 0 0 1.6859374999999999 -0.03125l6.2375 -7.796875a1.171875 1.171875 0 0 0 -0.015625 -1.640625z"
      strokeWidth="1"
    ></path>
  </svg>
);
export const cancelCircleicon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-0.5 -0.5 20 20"
    height="20"
    width="20"
    id="Cancel--Streamline-Material-Pro.svg"
  >
    <g id="Cancel--Streamline-Material-Pro.svg">
      <path
        id="cancel_2"
        fill="red"
        d="M6.650000000000001 13.458333333333334L9.5 10.608333333333334L12.350000000000001 13.458333333333334L13.458333333333334 12.350000000000001L10.608333333333334 9.5L13.458333333333334 6.650000000000001L12.350000000000001 5.541666666666667L9.5 8.391666666666667L6.650000000000001 5.541666666666667L5.541666666666667 6.650000000000001L8.391666666666667 9.5L5.541666666666667 12.350000000000001L6.650000000000001 13.458333333333334ZM9.5 17.416666666666668C8.404887500000001 17.416666666666668 7.375697083333335 17.20885416666667 6.4125000000000005 16.793229166666666C5.449302916666667 16.377604166666668 4.611458333333334 15.81354166666667 3.8989583333333337 15.101041666666667C3.186458333333334 14.388541666666669 2.6223958333333335 13.550720833333337 2.2067708333333336 12.587500000000002C1.7911458333333337 11.624279166666668 1.5833333333333335 10.5951125 1.5833333333333335 9.5C1.5833333333333335 8.404887500000001 1.7911458333333337 7.375697083333335 2.2067708333333336 6.4125000000000005C2.6223958333333335 5.449302916666667 3.186458333333334 4.611458333333334 3.8989583333333337 3.8989583333333337C4.611458333333334 3.186458333333334 5.449302916666667 2.6223958333333335 6.4125000000000005 2.2067708333333336C7.375697083333335 1.7911458333333337 8.404887500000001 1.5833333333333335 9.5 1.5833333333333335C10.5951125 1.5833333333333335 11.624279166666668 1.7911458333333337 12.587500000000002 2.2067708333333336C13.550720833333337 2.6223958333333335 14.388541666666669 3.186458333333334 15.101041666666667 3.8989583333333337C15.81354166666667 4.611458333333334 16.377604166666668 5.449302916666667 16.793229166666666 6.4125000000000005C17.20885416666667 7.375697083333335 17.416666666666668 8.404887500000001 17.416666666666668 9.5C17.416666666666668 10.5951125 17.20885416666667 11.624279166666668 16.793229166666666 12.587500000000002C16.377604166666668 13.550720833333337 15.81354166666667 14.388541666666669 15.101041666666667 15.101041666666667C14.388541666666669 15.81354166666667 13.550720833333337 16.377604166666668 12.587500000000002 16.793229166666666C11.624279166666668 17.20885416666667 10.5951125 17.416666666666668 9.5 17.416666666666668ZM9.5 15.833333333333336C11.268029166666668 15.833333333333336 12.765625000000002 15.21979166666667 13.992708333333335 13.992708333333335C15.21979166666667 12.765625000000002 15.833333333333336 11.268029166666668 15.833333333333336 9.5C15.833333333333336 7.731947083333334 15.21979166666667 6.234375000000001 13.992708333333335 5.007291666666667C12.765625000000002 3.780208333333334 11.268029166666668 3.166666666666667 9.5 3.166666666666667C7.731947083333334 3.166666666666667 6.234375000000001 3.780208333333334 5.007291666666667 5.007291666666667C3.780208333333334 6.234375000000001 3.166666666666667 7.731947083333334 3.166666666666667 9.5C3.166666666666667 11.268029166666668 3.780208333333334 12.765625000000002 5.007291666666667 13.992708333333335C6.234375000000001 15.21979166666667 7.731947083333334 15.833333333333336 9.5 15.833333333333336Z"
        strokeWidth="1"
      />
    </g>
  </svg>
);
export const showAllPhoto = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-columns-gap"
    viewBox="0 0 16 16"
  >
    <path d="M6 1v3H1V1zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm14 12v3h-5v-3zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM6 8v7H1V8zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm14-6v7h-5V1zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z" />
  </svg>
);
export const shareProfileButton = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-upload"
    viewBox="0 0 16 16"
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
  </svg>
);
export const saveProfile = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-heart"
    viewBox="0 0 16 16"
  >
    <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
  </svg>
);
export const removeProfile = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="16"
    height="16"
  >
    <path
      className="red-fill"
      d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
    />
  </svg>
);
export const instaFollowers = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="#c85ef7"
    className="bi bi-instagram"
    viewBox="0 0 16 16"
  >
    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
  </svg>
);

export const tiktokFollowers = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="#ED6AA2"
    className="bi bi-tiktok"
    viewBox="0 0 16 16"
  >
    <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z" />
  </svg>
);

export const youtubeFollowers = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="26"
    fill="#DC3545"
    className="bi bi-youtube"
    viewBox="0 0 16 16"
  >
    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
  </svg>
);
export const fbFollowers = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="#0082e7"
    className="bi bi-facebook"
    viewBox="0 0 16 16"
  >
    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
  </svg>
);

export const howDoesItWork = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    fill="currentColor"
    className="bi bi-info-circle"
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
  </svg>
);
export const playIconReport = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_560_20956)">
      <rect x="4" width="24" height="24" fill="white" />
      <rect x="4.5" y="0.5" width="23" height="23" stroke="#33CC33" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 18C19.3137 18 22 15.3137 22 12C22 8.68629 19.3137 6 16 6C12.6863 6 10 8.68629 10 12C10 15.3137 12.6863 18 16 18ZM16 20C20.4183 20 24 16.4183 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20Z"
        fill="#33CC33"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 9.88309V14.1169L18.5282 12L15 9.88309ZM14 9.88309C14 9.1058 14.848 8.62569 15.5145 9.0256L19.0427 11.1425C19.69 11.5309 19.69 12.4691 19.0427 12.8575L15.5145 14.9744C14.848 15.3743 14 14.8942 14 14.1169V9.88309Z"
        fill="#33CC33"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_560_20953"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_560_20953"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_560_20953"
          result="effect2_dropShadow_560_20953"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_560_20953"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const pauseIconReport = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_560_20956)">
      <rect x="4" width="24" height="24" fill="white" />
      <rect x="4.5" y="0.5" width="23" height="23" stroke="#EED202" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 18C19.3137 18 22 15.3137 22 12C22 8.68629 19.3137 6 16 6C12.6863 6 10 8.68629 10 12C10 15.3137 12.6863 18 16 18ZM16 20C20.4183 20 24 16.4183 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20Z"
        fill="#EED202"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 14.5V9.5H15V14.5H14Z"
        fill="#EED202"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17 14.5V9.5H18V14.5H17Z"
        fill="#EED202"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_560_20956"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_560_20956"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_560_20956"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const viewReport = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 7C6 5.89543 6.89543 5 8 5H9.5V7H8V18H16V7H14.5V5H16C17.1046 5 18 5.89543 18 7V18C18 19.1046 17.1046 20 16 20H8C6.89543 20 6 19.1046 6 18V7Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 5H10V7H14V5ZM10 4C9.44772 4 9 4.44772 9 5V7C9 7.55228 9.44772 8 10 8H14C14.5523 8 15 7.55228 15 7V5C15 4.44772 14.5523 4 14 4H10Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 12H10V11H14V12Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 15H10V14H14V15Z"
      fill="black"
    />
  </svg>
);
export const editReport = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.0858 4.49997C15.8668 3.71892 17.1332 3.71892 17.9142 4.49997L19.5 6.08576C20.281 6.86681 20.281 8.13314 19.5 8.91419L16.5 5.91418L11 11.4142V13H12.5858L18.0858 7.49997L19.5 8.91419L13.4142 15H9V10.5858L15.0858 4.49997Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.1464 9.85352L14.1464 6.85352L14.8536 6.14642L17.8536 9.14642L17.1464 9.85352Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 9.99997C4 8.8954 4.89543 7.99997 6 7.99997H7V9.99997L6 9.99997V18H14V17H16V18C16 19.1045 15.1046 20 14 20H6C4.89543 20 4 19.1045 4 18V9.99997Z"
      fill="black"
    />
  </svg>
);
export const addnewRow = (
  <svg width="25" height="25" viewBox="0 0 13 13" fill="green">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.9998 2.2998C6.33118 2.2998 6.5998 2.56843 6.5998 2.8998V5.8998H9.5998C9.93118 5.8998 10.1998 6.16843 10.1998 6.4998C10.1998 6.83118 9.93117 7.0998 9.5998 7.0998H6.5998V10.0998C6.5998 10.4312 6.33118 10.6998 5.9998 10.6998C5.66843 10.6998 5.3998 10.4312 5.3998 10.0998V7.0998H2.3998C2.06843 7.0998 1.7998 6.83117 1.7998 6.4998C1.7998 6.16843 2.06843 5.8998 2.3998 5.8998L5.3998 5.8998V2.8998C5.3998 2.56843 5.66843 2.2998 5.9998 2.2998Z"
      fill="green"
    />
  </svg>
);

export const infoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 54 54"
    fill="#73C2FB"
  >
    <rect width="48" height="48" rx="8" fill="#73C2FB" />
    <circle cx="24" cy="16" r="4" fill="white" />
    <rect x="22" y="24" width="4" height="12" fill="white" />
  </svg>
);

export const lockIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 13V17H15V13H9ZM8 11C7.44772 11 7 11.4477 7 12V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V12C17 11.4477 16.5523 11 16 11H8Z"
      fill="#B0BEC5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9V11H14V9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9V11H8V9Z"
      fill="#B0BEC5"
    />
  </svg>
);

export const visibleIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.99995 12L2.1679 12.5547L1.7981 12L2.1679 11.4453C2.1811 11.4255 2.19447 11.4054 2.20801 11.3851C3.52894 9.40282 6.46283 5 11.9999 5C14.8845 5 17.3728 6.71404 19.0532 8.2652C19.9108 9.0568 20.6004 9.84531 21.0756 10.4352C21.3138 10.7309 21.4997 10.9786 21.6275 11.1546C21.6914 11.2426 21.7409 11.3128 21.7752 11.3622C21.7923 11.3869 21.8057 11.4065 21.8152 11.4204L21.8265 11.4372L21.83 11.4423L21.8312 11.4441C21.8314 11.4444 21.832 11.4453 20.9999 12C21.832 12.5547 21.8318 12.555 21.8316 12.5552L21.83 12.5577L21.8265 12.5628L21.8152 12.5796C21.8057 12.5935 21.7923 12.6131 21.7752 12.6378C21.7409 12.6872 21.6914 12.7574 21.6275 12.8454C21.4997 13.0214 21.3138 13.2691 21.0756 13.5648C20.6004 14.1547 19.9108 14.9432 19.0532 15.7348C17.3728 17.286 14.8845 19 11.9999 19C9.11539 19 6.62708 17.286 4.94667 15.7348C4.08909 14.9432 3.39948 14.1547 2.92432 13.5648C2.68612 13.2691 2.50021 13.0214 2.37243 12.8454C2.30851 12.7574 2.25903 12.6872 2.22472 12.6378C2.20756 12.6131 2.19419 12.5935 2.18469 12.5796L2.17335 12.5628L2.16989 12.5577L2.16871 12.5559C2.16852 12.5556 2.1679 12.5547 2.99995 12ZM4.22077 11.9781C4.29733 12.078 4.38453 12.1894 4.48182 12.3102C4.91291 12.8453 5.5358 13.5568 6.30323 14.2652C7.87281 15.714 9.8845 17 11.9999 17C14.1154 17 16.1271 15.714 17.6967 14.2652C18.4641 13.5568 19.087 12.8453 19.5181 12.3102C19.6083 12.1981 19.6899 12.0942 19.7623 12C19.6899 11.9058 19.6083 11.8019 19.5181 11.6898C19.087 11.1547 18.4641 10.4432 17.6967 9.7348C16.1271 8.28596 14.1154 7 11.9999 7C7.98502 7 5.63886 9.91145 4.22077 11.9781ZM20.9999 12L21.8316 12.5552L22.2018 12L21.832 11.4453L20.9999 12Z"
      fill="#4CAF50"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9999 16C14.2091 16 15.9999 14.2091 15.9999 12C15.9999 9.79086 14.2091 8 11.9999 8C9.79081 8 7.99995 9.79086 7.99995 12C7.99995 14.2091 9.79081 16 11.9999 16ZM11.9999 17C14.7614 17 16.9999 14.7614 16.9999 12C16.9999 9.23858 14.7614 7 11.9999 7C9.23852 7 6.99995 9.23858 6.99995 12C6.99995 14.7614 9.23852 17 11.9999 17Z"
      fill="#4CAF50"
    />
    <path
      d="M13.9999 12C13.9999 13.1046 13.1045 14 11.9999 14C10.8954 14 9.99995 13.1046 9.99995 12C9.99995 10.8954 10.8954 10 11.9999 10C13.1045 10 13.9999 10.8954 13.9999 12Z"
      fill="#4CAF50"
    />
  </svg>
);

export const trashGalleryIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 6H19V8H18V18.75C18 19.4404 17.4404 20 16.75 20H7.25C6.55965 20 6 19.4404 6 18.75V8H5V6ZM8 8V18H16V8H8Z"
      fill="#F44336"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 5H9V3H15V5Z"
      fill="#F44336"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 17V9H11V17H10ZM13 17V9H14V17H13Z"
      fill="#F44336"
    />
  </svg>
);

export const addReview = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width="30"
    height="30"
  >
    <path
      fill="#333"
      d="M7.432 6.16a.333.333 0 0 1-.25.183l-1.27.185.919.895a.333.333 0 0 1 .096.295L6.71 8.982l1.135-.597a.333.333 0 0 1 .31 0l1.135.597-.217-1.264a.333.333 0 0 1 .096-.295l.919-.895-1.27-.185a.333.333 0 0 1-.25-.182L8 5.01l-.568 1.15zm.27-2.05a.333.333 0 0 1 .597 0l.789 1.599 1.764.256c.273.04.382.376.185.57L9.76 7.777l.301 1.757a.333.333 0 0 1-.484.351L8 9.056l-1.577.83a.333.333 0 0 1-.484-.351l.3-1.757-1.276-1.244a.333.333 0 0 1 .185-.569l1.764-.256.79-1.599zm-4.23 7.953a3.853 3.853 0 0 1 2.195-.73H13a.333.333 0 0 0 .333-.333V3A.333.333 0 0 0 13 2.667H3A.333.333 0 0 0 2.667 3v9.867c.225-.303.496-.574.804-.804zM13 2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5.672a3.179 3.179 0 0 0-1.806.6 3.235 3.235 0 0 0-1.21 1.814c-.094.382-.656.313-.656-.08V3a1 1 0 0 1 1-1h10z"
    />
  </svg>
);

export const downloadCSV = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2199 20.75H5.77994C5.43316 20.7359 5.09256 20.6535 4.77765 20.5075C4.46274 20.3616 4.17969 20.155 3.9447 19.8996C3.70971 19.6442 3.52739 19.3449 3.40818 19.019C3.28896 18.693 3.23519 18.3468 3.24994 18V15C3.24994 14.8011 3.32896 14.6103 3.46961 14.4697C3.61027 14.329 3.80103 14.25 3.99994 14.25C4.19886 14.25 4.38962 14.329 4.53027 14.4697C4.67093 14.6103 4.74994 14.8011 4.74994 15V18C4.72412 18.2969 4.81359 18.5924 4.99977 18.8251C5.18596 19.0579 5.45459 19.21 5.74994 19.25H18.2199C18.5153 19.21 18.7839 19.0579 18.9701 18.8251C19.1563 18.5924 19.2458 18.2969 19.2199 18V15C19.2199 14.8011 19.299 14.6103 19.4396 14.4697C19.5803 14.329 19.771 14.25 19.9699 14.25C20.1689 14.25 20.3596 14.329 20.5003 14.4697C20.6409 14.6103 20.7199 14.8011 20.7199 15V18C20.7499 18.6954 20.504 19.3744 20.0358 19.8894C19.5676 20.4045 18.915 20.7137 18.2199 20.75Z"
      fill="black"
    />
    <path
      d="M12 15.75C11.9014 15.7504 11.8038 15.7312 11.7128 15.6934C11.6218 15.6557 11.5392 15.6001 11.47 15.53L7.46997 11.53C7.33749 11.3878 7.26537 11.1997 7.26879 11.0054C7.27222 10.8111 7.35093 10.6258 7.48835 10.4883C7.62576 10.3509 7.81115 10.2722 8.00545 10.2688C8.19975 10.2654 8.38779 10.3375 8.52997 10.47L12 13.94L15.47 10.47C15.6121 10.3375 15.8002 10.2654 15.9945 10.2688C16.1888 10.2722 16.3742 10.3509 16.5116 10.4883C16.649 10.6258 16.7277 10.8111 16.7311 11.0054C16.7346 11.1997 16.6624 11.3878 16.53 11.53L12.53 15.53C12.4607 15.6001 12.3782 15.6557 12.2872 15.6934C12.1961 15.7312 12.0985 15.7504 12 15.75Z"
      fill="black"
    />
    <path
      d="M12 15.75C11.8019 15.7474 11.6126 15.6676 11.4725 15.5275C11.3324 15.3874 11.2526 15.1981 11.25 15V4C11.25 3.80109 11.329 3.61032 11.4697 3.46967C11.6103 3.32902 11.8011 3.25 12 3.25C12.1989 3.25 12.3897 3.32902 12.5303 3.46967C12.671 3.61032 12.75 3.80109 12.75 4V15C12.7474 15.1981 12.6676 15.3874 12.5275 15.5275C12.3874 15.6676 12.1981 15.7474 12 15.75Z"
      fill="black"
    />
  </svg>
);

export const chatIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.24999 17.31C4.12892 17.3121 4.00915 17.2849 3.9009 17.2306C3.79266 17.1763 3.69916 17.0966 3.62841 16.9984C3.55766 16.9001 3.51175 16.7862 3.49461 16.6663C3.47747 16.5464 3.48961 16.4242 3.52999 16.31L4.77999 12.19C4.52436 11.4877 4.38913 10.7473 4.37999 10C4.37802 9.13743 4.55154 8.28345 4.88999 7.49003C5.30028 6.51286 5.94398 5.65124 6.76468 4.98069C7.58537 4.31013 8.55801 3.85109 9.59735 3.64382C10.6367 3.43654 11.711 3.48735 12.7261 3.79179C13.7413 4.09623 14.6662 4.64501 15.42 5.39003C16.0049 5.98425 16.473 6.68303 16.8 7.45003C17.1322 8.24163 17.3033 9.09152 17.3033 9.95003C17.3033 10.8085 17.1322 11.6584 16.8 12.45C16.473 13.217 16.0049 13.9158 15.42 14.51C14.5431 15.3854 13.4337 15.9909 12.2231 16.255C11.0126 16.5191 9.75176 16.4306 8.58999 16L4.46999 17.28C4.39833 17.2998 4.32434 17.3099 4.24999 17.31ZM10.84 5.00003C10.1769 4.9981 9.52031 5.13078 8.90999 5.39003C7.72766 5.88899 6.78244 6.82347 6.26999 8.00003C6.01284 8.61273 5.88039 9.27055 5.88039 9.93503C5.88039 10.5995 6.01284 11.2573 6.26999 11.87C6.32957 12.0348 6.32957 12.2152 6.26999 12.38L5.34999 15.38L8.34999 14.46C8.51477 14.4005 8.69521 14.4005 8.85999 14.46C10.0743 14.9643 11.4383 14.97 12.6567 14.4759C13.8752 13.9818 14.85 13.0276 15.37 11.82C15.6626 11.072 15.7707 10.2646 15.6852 9.46592C15.5996 8.6673 15.323 7.90103 14.8786 7.23198C14.4342 6.56293 13.8351 6.01078 13.1321 5.62227C12.4292 5.23376 11.6429 5.02033 10.84 5.00003Z"
      fill="black"
    />
    <path
      d="M19.75 20.5001C19.677 20.5098 19.603 20.5098 19.53 20.5001L15.41 19.2501C13.8622 19.8345 12.1485 19.7988 10.6263 19.1505C9.10414 18.5021 7.89104 17.2911 7.24004 15.7701C7.19554 15.6801 7.17009 15.5818 7.16527 15.4816C7.16045 15.3813 7.17637 15.2811 7.21204 15.1872C7.2477 15.0934 7.30234 15.0079 7.37254 14.9361C7.44275 14.8643 7.527 14.8078 7.62004 14.7701C7.71052 14.7285 7.80837 14.7053 7.90789 14.7019C8.00742 14.6986 8.10661 14.715 8.1997 14.7504C8.29279 14.7858 8.3779 14.8393 8.45006 14.908C8.52223 14.9766 8.58001 15.0589 8.62004 15.1501C8.85773 15.7165 9.19659 16.235 9.62004 16.6801C10.3212 17.3735 11.2118 17.8442 12.1797 18.0328C13.1477 18.2214 14.1498 18.1195 15.06 17.7401C15.2248 17.6805 15.4053 17.6805 15.57 17.7401L18.57 18.6601L17.65 15.6601C17.5905 15.4953 17.5905 15.3148 17.65 15.1501C17.9093 14.5397 18.042 13.8832 18.04 13.2201C18.0424 12.5682 17.9155 11.9223 17.6666 11.3198C17.4177 10.7173 17.0518 10.1702 16.59 9.71006C16.3877 9.45441 16.1635 9.21684 15.92 9.00006C15.8326 8.9476 15.7568 8.87786 15.6972 8.79511C15.6376 8.71236 15.5956 8.61833 15.5736 8.51877C15.5516 8.41921 15.5501 8.3162 15.5693 8.21606C15.5884 8.11591 15.6278 8.02072 15.685 7.9363C15.7421 7.85188 15.8159 7.78001 15.9018 7.72508C15.9878 7.67015 16.084 7.63331 16.1846 7.61681C16.2852 7.60032 16.3881 7.60451 16.4871 7.62914C16.586 7.65377 16.6789 7.69832 16.76 7.76006C17.1178 7.99097 17.4526 8.2555 17.76 8.55006C18.3482 9.14166 18.8167 9.84108 19.14 10.6101C19.4793 11.4067 19.6528 12.2642 19.65 13.1301C19.6479 13.8976 19.5126 14.6589 19.25 15.3801L20.5 19.5001C20.5404 19.6142 20.5526 19.7365 20.5354 19.8563C20.5183 19.9762 20.4724 20.0901 20.4016 20.1884C20.3309 20.2867 20.2374 20.3663 20.1291 20.4206C20.0209 20.4749 19.9011 20.5021 19.78 20.5001H19.75Z"
      fill="black"
    />
  </svg>
);

export const reportSpam = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4199 4.44994C19.3203 4.38116 19.2052 4.3379 19.0849 4.32395C18.9646 4.31 18.8427 4.32579 18.7299 4.36994C17.5424 4.8846 16.2856 5.22155 14.9999 5.36994C14.1878 5.15273 13.4127 4.81569 12.6999 4.36994C11.7801 3.80143 10.763 3.40813 9.69994 3.20994C8.40994 3.08994 5.33994 4.09994 4.69994 4.30994C4.55138 4.36012 4.42228 4.4556 4.3308 4.58295C4.23932 4.71031 4.19006 4.86314 4.18994 5.01994V19.9999C4.18994 20.1989 4.26896 20.3896 4.40961 20.5303C4.55026 20.6709 4.74103 20.7499 4.93994 20.7499C5.13885 20.7499 5.32962 20.6709 5.47027 20.5303C5.61092 20.3896 5.68994 20.1989 5.68994 19.9999V14.1399C6.93653 13.6982 8.23309 13.4127 9.54994 13.2899C10.3966 13.4978 11.2062 13.8351 11.9499 14.2899C12.8201 14.8218 13.7733 15.2038 14.7699 15.4199H14.9999C16.4474 15.2326 17.8633 14.8526 19.2099 14.2899C19.3505 14.2342 19.4713 14.1379 19.5568 14.0132C19.6423 13.8885 19.6886 13.7411 19.6899 13.5899V5.06994C19.6974 4.95258 19.6769 4.83512 19.6299 4.7273C19.5829 4.61947 19.511 4.5244 19.4199 4.44994Z"
      fill="#FE0404"
    />
  </svg>
);

export const reportError = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3C10.22 3 8.47991 3.52784 6.99987 4.51677C5.51983 5.50571 4.36628 6.91131 3.68509 8.55585C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89472 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.387 3 12 3ZM4.5 12C4.49849 10.2704 5.09961 8.59437 6.2 7.26L16.74 17.8C15.6426 18.7001 14.3119 19.2699 12.9031 19.443C11.4943 19.616 10.0654 19.3852 8.78268 18.7774C7.50001 18.1696 6.41645 17.2098 5.65823 16.0099C4.9 14.81 4.49833 13.4194 4.5 12ZM17.8 16.74L7.26 6.2C8.69757 5.02356 10.521 4.42329 12.3763 4.51573C14.2315 4.60817 15.9863 5.38672 17.2998 6.70022C18.6133 8.01372 19.3918 9.76846 19.4843 11.6237C19.5767 13.479 18.9764 15.3024 17.8 16.74Z"
      fill="black"
    />
  </svg>
);

export const downloadImgInChat = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2199 20.75H5.77994C5.43316 20.7359 5.09256 20.6535 4.77765 20.5075C4.46274 20.3616 4.17969 20.155 3.9447 19.8996C3.70971 19.6442 3.52739 19.3449 3.40818 19.019C3.28896 18.693 3.23519 18.3468 3.24994 18V15C3.24994 14.8011 3.32896 14.6103 3.46961 14.4697C3.61027 14.329 3.80103 14.25 3.99994 14.25C4.19886 14.25 4.38962 14.329 4.53027 14.4697C4.67093 14.6103 4.74994 14.8011 4.74994 15V18C4.72412 18.2969 4.81359 18.5924 4.99977 18.8251C5.18596 19.0579 5.45459 19.21 5.74994 19.25H18.2199C18.5153 19.21 18.7839 19.0579 18.9701 18.8251C19.1563 18.5924 19.2458 18.2969 19.2199 18V15C19.2199 14.8011 19.299 14.6103 19.4396 14.4697C19.5803 14.329 19.771 14.25 19.9699 14.25C20.1689 14.25 20.3596 14.329 20.5003 14.4697C20.6409 14.6103 20.7199 14.8011 20.7199 15V18C20.7499 18.6954 20.504 19.3744 20.0358 19.8894C19.5676 20.4045 18.915 20.7137 18.2199 20.75Z"
      fill="black"
    />
    <path
      d="M12 15.75C11.9014 15.7504 11.8038 15.7312 11.7128 15.6934C11.6218 15.6557 11.5392 15.6001 11.47 15.53L7.46997 11.53C7.33749 11.3878 7.26537 11.1997 7.26879 11.0054C7.27222 10.8111 7.35093 10.6258 7.48835 10.4883C7.62576 10.3509 7.81115 10.2722 8.00545 10.2688C8.19975 10.2654 8.38779 10.3375 8.52997 10.47L12 13.94L15.47 10.47C15.6121 10.3375 15.8002 10.2654 15.9945 10.2688C16.1888 10.2722 16.3742 10.3509 16.5116 10.4883C16.649 10.6258 16.7277 10.8111 16.7311 11.0054C16.7346 11.1997 16.6624 11.3878 16.53 11.53L12.53 15.53C12.4607 15.6001 12.3782 15.6557 12.2872 15.6934C12.1961 15.7312 12.0985 15.7504 12 15.75Z"
      fill="black"
    />
    <path
      d="M12 15.75C11.8019 15.7474 11.6126 15.6676 11.4725 15.5275C11.3324 15.3874 11.2526 15.1981 11.25 15V4C11.25 3.80109 11.329 3.61032 11.4697 3.46967C11.6103 3.32902 11.8011 3.25 12 3.25C12.1989 3.25 12.3897 3.32902 12.5303 3.46967C12.671 3.61032 12.75 3.80109 12.75 4V15C12.7474 15.1981 12.6676 15.3874 12.5275 15.5275C12.3874 15.6676 12.1981 15.7474 12 15.75Z"
      fill="black"
    />
  </svg>
);

export const AiLogo = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.5 59.5">
    <g>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M58.75,34.38v-9.26l-7.17-.99c-.53-2.08-1.35-4.04-2.42-5.84l4.36-5.77-6.55-6.55-5.77,4.36
        c-1.8-1.07-3.76-1.88-5.84-2.42l-.99-7.17h-9.26l-.99,7.17c-2.08.53-4.04,1.35-5.84,2.42l-5.77-4.36-6.55,6.55
        4.36,5.77c-1.07,1.8-1.88,3.76-2.42,5.84l-7.17.99v9.26l7.17.99c.53,2.08,1.35,4.04,2.42,5.84l-4.36,5.77,6.55,6.55
        5.77-4.36c1.8,1.07,3.76,1.88,5.84,2.42l.99,7.17h9.26l.99-7.17c2.08-.53,4.04-1.35,5.84-2.42l5.77,4.36,6.55-6.55
        -4.36-5.77c1.07-1.8,1.88-3.76,2.42-5.84l7.17-.99Z"
      />
      <polyline
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        points="33.97 37.66 26.22 20.97 18.47 37.66"
      />
      <line
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        x1="31.57"
        y1="32.51"
        x2="20.86"
        y2="32.51"
      />
      <line
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        x1="39.52"
        y1="20.97"
        x2="39.52"
        y2="37.66"
      />
    </g>
  </svg>
);

export const chatIconWhite = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.24999 17.31C4.12892 17.3121 4.00915 17.2849 3.9009 17.2306C3.79266 17.1763 3.69916 17.0966 3.62841 16.9984C3.55766 16.9001 3.51175 16.7862 3.49461 16.6663C3.47747 16.5464 3.48961 16.4242 3.52999 16.31L4.77999 12.19C4.52436 11.4877 4.38913 10.7473 4.37999 10C4.37802 9.13743 4.55154 8.28345 4.88999 7.49003C5.30028 6.51286 5.94398 5.65124 6.76468 4.98069C7.58537 4.31013 8.55801 3.85109 9.59735 3.64382C10.6367 3.43654 11.711 3.48735 12.7261 3.79179C13.7413 4.09623 14.6662 4.64501 15.42 5.39003C16.0049 5.98425 16.473 6.68303 16.8 7.45003C17.1322 8.24163 17.3033 9.09152 17.3033 9.95003C17.3033 10.8085 17.1322 11.6584 16.8 12.45C16.473 13.217 16.0049 13.9158 15.42 14.51C14.5431 15.3854 13.4337 15.9909 12.2231 16.255C11.0126 16.5191 9.75176 16.4306 8.58999 16L4.46999 17.28C4.39833 17.2998 4.32434 17.3099 4.24999 17.31ZM10.84 5.00003C10.1769 4.9981 9.52031 5.13078 8.90999 5.39003C7.72766 5.88899 6.78244 6.82347 6.26999 8.00003C6.01284 8.61273 5.88039 9.27055 5.88039 9.93503C5.88039 10.5995 6.01284 11.2573 6.26999 11.87C6.32957 12.0348 6.32957 12.2152 6.26999 12.38L5.34999 15.38L8.34999 14.46C8.51477 14.4005 8.69521 14.4005 8.85999 14.46C10.0743 14.9643 11.4383 14.97 12.6567 14.4759C13.8752 13.9818 14.85 13.0276 15.37 11.82C15.6626 11.072 15.7707 10.2646 15.6852 9.46592C15.5996 8.6673 15.323 7.90103 14.8786 7.23198C14.4342 6.56293 13.8351 6.01078 13.1321 5.62227C12.4292 5.23376 11.6429 5.02033 10.84 5.00003Z"
      fill="#33cc33"
    />
    <path
      d="M19.75 20.5001C19.677 20.5098 19.603 20.5098 19.53 20.5001L15.41 19.2501C13.8622 19.8345 12.1485 19.7988 10.6263 19.1505C9.10414 18.5021 7.89104 17.2911 7.24004 15.7701C7.19554 15.6801 7.17009 15.5818 7.16527 15.4816C7.16045 15.3813 7.17637 15.2811 7.21204 15.1872C7.2477 15.0934 7.30234 15.0079 7.37254 14.9361C7.44275 14.8643 7.527 14.8078 7.62004 14.7701C7.71052 14.7285 7.80837 14.7053 7.90789 14.7019C8.00742 14.6986 8.10661 14.715 8.1997 14.7504C8.29279 14.7858 8.3779 14.8393 8.45006 14.908C8.52223 14.9766 8.58001 15.0589 8.62004 15.1501C8.85773 15.7165 9.19659 16.235 9.62004 16.6801C10.3212 17.3735 11.2118 17.8442 12.1797 18.0328C13.1477 18.2214 14.1498 18.1195 15.06 17.7401C15.2248 17.6805 15.4053 17.6805 15.57 17.7401L18.57 18.6601L17.65 15.6601C17.5905 15.4953 17.5905 15.3148 17.65 15.1501C17.9093 14.5397 18.042 13.8832 18.04 13.2201C18.0424 12.5682 17.9155 11.9223 17.6666 11.3198C17.4177 10.7173 17.0518 10.1702 16.59 9.71006C16.3877 9.45441 16.1635 9.21684 15.92 9.00006C15.8326 8.9476 15.7568 8.87786 15.6972 8.79511C15.6376 8.71236 15.5956 8.61833 15.5736 8.51877C15.5516 8.41921 15.5501 8.3162 15.5693 8.21606C15.5884 8.11591 15.6278 8.02072 15.685 7.9363C15.7421 7.85188 15.8159 7.78001 15.9018 7.72508C15.9878 7.67015 16.084 7.63331 16.1846 7.61681C16.2852 7.60032 16.3881 7.60451 16.4871 7.62914C16.586 7.65377 16.6789 7.69832 16.76 7.76006C17.1178 7.99097 17.4526 8.2555 17.76 8.55006C18.3482 9.14166 18.8167 9.84108 19.14 10.6101C19.4793 11.4067 19.6528 12.2642 19.65 13.1301C19.6479 13.8976 19.5126 14.6589 19.25 15.3801L20.5 19.5001C20.5404 19.6142 20.5526 19.7365 20.5354 19.8563C20.5183 19.9762 20.4724 20.0901 20.4016 20.1884C20.3309 20.2867 20.2374 20.3663 20.1291 20.4206C20.0209 20.4749 19.9011 20.5021 19.78 20.5001H19.75Z"
      fill="#33cc33"
    />
  </svg>
);

export const aiiconWhite = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.5 59.5">
    <g>
      <path
        fill="#33cc33"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M58.75,34.38v-9.26l-7.17-.99c-.53-2.08-1.35-4.04-2.42-5.84l4.36-5.77-6.55-6.55-5.77,4.36
        c-1.8-1.07-3.76-1.88-5.84-2.42l-.99-7.17h-9.26l-.99,7.17c-2.08.53-4.04,1.35-5.84,2.42l-5.77-4.36-6.55,6.55
        4.36,5.77c-1.07,1.8-1.88,3.76-2.42,5.84l-7.17.99v9.26l7.17.99c.53,2.08,1.35,4.04,2.42,5.84l-4.36,5.77,6.55,6.55
        5.77-4.36c1.8,1.07,3.76,1.88,5.84,2.42l.99,7.17h9.26l.99-7.17c2.08-.53,4.04-1.35,5.84-2.42l5.77,4.36,6.55-6.55
        -4.36-5.77c1.07-1.8,1.88-3.76,2.42-5.84l7.17-.99Z"
      />
      <polyline
        fill="#33cc33"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        points="33.97 37.66 26.22 20.97 18.47 37.66"
      />
      <line
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        x1="31.57"
        y1="32.51"
        x2="20.86"
        y2="32.51"
      />
      <line
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        x1="39.52"
        y1="20.97"
        x2="39.52"
        y2="37.66"
      />
    </g>
  </svg>
);

export const Separator = ({ color = "#E0E0E0", margin = "8px 0" }) => (
  <div
    style={{
      borderTop: `1px solid ${color}`,
      margin,
      width: "100%",
    }}
  />
);

export const redirecttoPage = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21C10.22 21 8.47991 20.4722 6.99987 19.4832C5.51983 18.4943 4.36628 17.0887 3.68509 15.4442C3.0039 13.7996 2.82567 11.99 3.17294 10.2442C3.5202 8.49836 4.37737 6.89472 5.63604 5.63604C6.89472 4.37737 8.49836 3.5202 10.2442 3.17294C11.99 2.82567 13.7996 3.0039 15.4442 3.68509C17.0887 4.36628 18.4943 5.51983 19.4832 6.99987C20.4722 8.47991 21 10.22 21 12C21 14.387 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.387 21 12 21ZM12 4.5C10.5166 4.5 9.0666 4.93987 7.83323 5.76398C6.59986 6.58809 5.63856 7.75943 5.07091 9.12988C4.50325 10.5003 4.35473 12.0083 4.64411 13.4632C4.9335 14.918 5.64781 16.2544 6.6967 17.3033C7.7456 18.3522 9.08197 19.0665 10.5368 19.3559C11.9917 19.6453 13.4997 19.4968 14.8701 18.9291C16.2406 18.3614 17.4119 17.4001 18.236 16.1668C19.0601 14.9334 19.5 13.4834 19.5 12C19.5 10.0109 18.7098 8.10323 17.3033 6.6967C15.8968 5.29018 13.9891 4.5 12 4.5Z"
      fill="black"
    />
    <path
      d="M12 16.75C11.9014 16.7504 11.8038 16.7312 11.7128 16.6934C11.6217 16.6557 11.5392 16.6001 11.47 16.53C11.3295 16.3893 11.2506 16.1987 11.2506 16C11.2506 15.8012 11.3295 15.6106 11.47 15.47L14.9399 12L11.47 8.52997C11.3375 8.38779 11.2653 8.19975 11.2688 8.00545C11.2722 7.81115 11.3509 7.62576 11.4883 7.48835C11.6257 7.35093 11.8111 7.27222 12.0054 7.26879C12.1997 7.26537 12.3878 7.33749 12.53 7.46997L16.53 11.47C16.6704 11.6106 16.7493 11.8012 16.7493 12C16.7493 12.1987 16.6704 12.3893 16.53 12.53L12.53 16.53C12.4607 16.6001 12.3782 16.6557 12.2871 16.6934C12.1961 16.7312 12.0985 16.7504 12 16.75Z"
      fill="black"
    />
    <path
      d="M16 12.75H8C7.80109 12.75 7.61032 12.671 7.46967 12.5303C7.32902 12.3897 7.25 12.1989 7.25 12C7.25 11.8011 7.32902 11.6103 7.46967 11.4697C7.61032 11.329 7.80109 11.25 8 11.25H16C16.1989 11.25 16.3897 11.329 16.5303 11.4697C16.671 11.6103 16.75 11.8011 16.75 12C16.75 12.1989 16.671 12.3897 16.5303 12.5303C16.3897 12.671 16.1989 12.75 16 12.75Z"
      fill="black"
    />
  </svg>
);

export const documentIcon = (
  <svg
    width="100"
    height="100"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="8" fill="#E2E8F0" />
    <path
      d="M16 8C14.8954 8 14 8.89543 14 10V54C14 55.1046 14.8954 56 16 56H48C49.1046 56 50 55.1046 50 54V22.8284C50 22.2974 49.7893 21.7893 49.4142 21.4142L34.5858 6.58579C34.2107 6.21071 33.7026 6 33.1716 6H16Z"
      fill="white"
    />
    <path d="M34 6V20C34 21.1046 34.8954 22 36 22H50" fill="#CBD5E1" />
    <path
      d="M24 30H40M24 36H40M24 42H40"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
